import { jsxs as v, Fragment as ie, jsx as n } from "react/jsx-runtime";
import Qn, { useMemo as F, useState as _, useEffect as U, useCallback as oe, useRef as re, forwardRef as ei, createContext as ti, useContext as ni, useLayoutEffect as an, createRef as ii } from "react";
import { useTheme as le, styled as m, Box as S, Skeleton as z, Grid as ae, Link as ye, darken as yt, Button as $e, Divider as wt, TextField as ot, InputAdornment as vt, Checkbox as ln, Tooltip as ue, IconButton as fe, debounce as ri, Slider as xt, TableCell as bt, Table as sn, TableHead as cn, TableRow as Je, TableBody as dn, TableContainer as un, TableSortLabel as oi, TablePagination as ai, Menu as kt, MenuItem as Pe, SvgIcon as je, lighten as pn, Typography as De, ClickAwayListener as li, ToggleButton as si, capitalize as gn, ListItem as ci, Chip as di, List as ui, Paper as hn, Popover as pi, Select as gi, ListItemText as hi, Collapse as St, Drawer as fi, Icon as mi, LinearProgress as yi } from "@mui/material";
import { useIntl as se } from "react-intl";
import { d as wi, u as ce, T as H, S as B, B as Mt, a as vi, b as pt } from "../TablePaginationActions-EDxBCxpG.js";
import xi from "echarts-for-react";
import { FixedSizeList as bi } from "react-window";
import { S as Qe, a as ki } from "../SwatchSquare-CVpwEFFV.js";
import { ChevronLeft as Si, ChevronRight as Mi, KeyboardArrowDown as Ii, ErrorOutline as Ti, Cancel as Ci, VisibilityOutlined as Ai, VisibilityOffOutlined as Ei, ExpandLess as fn, ExpandMore as mn, Close as Li, LayersOutlined as Di, MoreVert as $i } from "@mui/icons-material";
import { A as Pi } from "../Alert-CZgNmICd.js";
import { c as yn, a as Oi, b as wn } from "../paletteUtils-BEwZhrLg.js";
function vn() {
  let e = !1;
  return window.PointerEvent && "maxTouchPoints" in navigator ? navigator.maxTouchPoints > 0 && (e = !0) : (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches || window.TouchEvent || "ontouchstart" in window) && (e = !0), e;
}
function ge(e) {
  return !e || typeof e != "object" ? e : `${e.prefix ?? ""}${e.value}${e.suffix ?? ""}`;
}
const Wi = [], Ri = {}, Ot = (e) => e;
function Fi(e, t) {
  if (!e || Array.isArray(e) && e.length === 0)
    return null;
  const i = Array.isArray(e) ? e : [e];
  let r = "";
  return r += String(
    i[0].axisValueLabel
  ), r += i.map(({ seriesName: o, value: a, data: l, marker: d }) => {
    const s = o ? o + ": " : "", u = ge(
      t(Number(a))
    ), p = l, c = `<div style="margin-left: 8px; display: inline">
        ${s}${u}${String((p == null ? void 0 : p.unit) || "")}
        </div>`;
    return `<div style="margin-top: 4px">${String(d)}${c}</div>`;
  }).join(" "), r;
}
function Ni({
  height: e,
  labels: t = Ri,
  yAxisData: i,
  selectedBars: r = Wi,
  series: o,
  colors: a,
  tooltip: l = !0,
  tooltipFormatter: d = Fi,
  xAxisFormatter: s = Ot,
  yAxisFormatter: u = Ot,
  onSelectedBarsChange: p,
  animation: c = !0,
  filterable: y = !0,
  stacked: g = !0,
  ...f
}) {
  const w = le(), h = F(
    () => (o ?? []).map((M) => t[M] ?? M),
    [o, t]
  ), b = F(
    () => Array.isArray(i[0]) ? i : [i],
    [i]
  ), k = F(() => typeof a == "string" ? [a] : Array.isArray(a) && a.length ? a : b.length <= 1 || h.length === 1 ? [w.palette.secondary.main] : b.length === 2 || h.length === 2 ? [w.palette.secondary.light, w.palette.secondary.dark] : Object.values(w.palette.qualitative.bold || {}), [a, w, b, h]);
  return {
    ...f,
    tooltip: l,
    tooltipFormatter: d,
    xAxisFormatter: s,
    yAxisFormatter: u,
    onSelectedBarsChange: p,
    animation: c,
    filterable: y,
    stacked: g,
    labels: t,
    height: e ?? parseInt(w.spacing(22)),
    // parseInt removes 'px' from the string,
    selectedBars: Bi(r),
    yAxisData: b,
    colors: k,
    series: h
  };
}
function Bi(e) {
  return (e ?? []).length ? e.map((t) => Array.isArray(t) && t.length === 2 ? t : Array.isArray(t) ? [...Array(2)].map((r, o) => t[o] ?? 0) : [t, 0]) : [];
}
var _i = function e(t, i) {
  if (t === i) return !0;
  if (t && i && typeof t == "object" && typeof i == "object") {
    if (t.constructor !== i.constructor) return !1;
    var r, o, a;
    if (Array.isArray(t)) {
      if (r = t.length, r != i.length) return !1;
      for (o = r; o-- !== 0; )
        if (!e(t[o], i[o])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === i.source && t.flags === i.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === i.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === i.toString();
    if (a = Object.keys(t), r = a.length, r !== Object.keys(i).length) return !1;
    for (o = r; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(i, a[o])) return !1;
    for (o = r; o-- !== 0; ) {
      var l = a[o];
      if (!e(t[l], i[l])) return !1;
    }
    return !0;
  }
  return t !== t && i !== i;
};
const Le = /* @__PURE__ */ wi(_i);
class We extends xi {
  componentDidUpdate(t) {
    const { shouldSetOption: i } = this.props;
    if (typeof i == "function" && !i(t, this.props))
      return;
    if (!Le(t.theme, this.props.theme) || !Le(t.opts, this.props.opts)) {
      this.dispose(), this.renderNewEcharts();
      return;
    }
    const r = this.getEchartsInstance();
    Le(t.onEvents, this.props.onEvents) || (this.offEvents(r, t.onEvents), this.bindEvents(r, this.props.onEvents));
    const o = [
      "option",
      "notMerge",
      "lazyUpdate",
      "showLoading",
      "loadingOption"
    ];
    Le(Wt(this.props, o), Wt(t, o)) || this.updateEChartsOption(), (!Le(t.style, this.props.style) || !Le(t.className, this.props.className)) && this.resize();
  }
  updateEChartsOption() {
    const t = this.props.option, i = this.props.loadingOption || null, { lazyUpdate: r, showLoading: o } = this.props, a = this.getEchartsInstance();
    return a.setOption(t, { replaceMerge: ["series"], lazyUpdate: r }), o ? a.showLoading(i) : a.hideLoading(), a;
  }
  offEvents(t, i) {
    if (i)
      for (const r in i)
        typeof r == "string" && t.off(r);
  }
}
function Wt(e, t) {
  const i = {};
  return t.forEach((r) => {
    i[r] = e[r];
  }), i;
}
const at = 240, xn = m(S)(({ theme: e }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  position: "relative",
  padding: e.spacing(0, 2),
  // Linear grid effect
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    backgroundSize: e.spacing(4, 4),
    backgroundImage: `linear-gradient(to bottom, ${e.palette.grey[50]} 1px, transparent 1px)`,
    transform: "scaleY(-1)"
  }
})), bn = m(S)(({ theme: e }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  // Square grid effect
  backgroundImage: `linear-gradient(${e.palette.grey[50]} 0.5px, transparent 0.5px, transparent calc(100% - 0.5px), ${e.palette.grey[50]} calc(100% - 0.5px)), linear-gradient(90deg, ${e.palette.grey[50]} 0.5px, transparent 0.5px, transparent calc(100% - 0.5px), ${e.palette.grey[50]} calc(100% - 0.5px))`,
  backgroundSize: "8.33% 20%",
  border: `0.5px solid ${e.palette.grey[50]}`
})), Fe = m(z)(({ theme: e }) => ({
  flex: 1,
  maxWidth: e.spacing(12),
  "& + &": {
    marginLeft: e.spacing(1)
  }
})), he = m(z)(({ theme: e }) => ({
  flex: 1,
  maxWidth: e.spacing(8),
  "& + &": {
    marginLeft: "1px"
  }
})), Hi = m(z)(({ theme: e }) => ({
  backgroundColor: e.palette.common.white
})), Rt = m(z)(({ theme: e }) => ({
  backgroundColor: e.palette.grey[100]
}));
function zi({ height: e }) {
  return /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(S, { mb: 2, children: /* @__PURE__ */ n(z, { width: 48, height: 8 }) }),
    /* @__PURE__ */ v(xn, { style: { height: e || at }, children: [
      /* @__PURE__ */ n(Fe, { variant: "rectangular", height: "20%" }),
      /* @__PURE__ */ n(Fe, { variant: "rectangular", height: "40%" }),
      /* @__PURE__ */ n(Fe, { variant: "rectangular", height: "60%" }),
      /* @__PURE__ */ n(Fe, { variant: "rectangular", height: "20%" }),
      /* @__PURE__ */ n(Fe, { variant: "rectangular", height: "80%" })
    ] })
  ] });
}
function ke(e) {
  const [t, i] = _(!1), [r, o] = _(!1);
  return U(() => {
    e && !r && (i(!0), o(!0)), e || i(!1);
  }, [e, r]), { showSkeleton: t };
}
const ji = vn(), Yi = m(ae)(({ theme: e }) => ({
  marginBottom: e.spacing(2),
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  "& .MuiTypography-caption": {
    color: e.palette.text.secondary
  }
})), Vi = m(ye)(({ theme: e }) => ({
  ...e.typography.caption,
  cursor: "pointer"
}));
function is(e) {
  const {
    yAxisData: t,
    xAxisData: i,
    series: r,
    selectedBars: o,
    onSelectedBarsChange: a,
    tooltip: l,
    tooltipFormatter: d,
    labels: s,
    colors: u,
    xAxisFormatter: p,
    yAxisFormatter: c,
    stacked: y,
    height: g,
    filterable: f,
    animation: w,
    isLoading: h
  } = Ni(e), b = r.length > 1, k = le(), M = se(), T = ce(M), { showSkeleton: x } = ke(!!h), A = F(
    () => ({
      show: l,
      trigger: "axis",
      padding: [parseInt(k.spacing(0.5)), parseInt(k.spacing(1))],
      borderWidth: 0,
      textStyle: {
        ...k.typography.caption,
        fontSize: 11,
        color: k.palette.common.white
      },
      backgroundColor: k.palette.black[90],
      position: function(I, R, X, j, K) {
        const te = { top: 0 };
        return K.contentSize[0] < K.viewSize[0] - I[0] ? te.left = I[0] : te.right = K.viewSize[0] - I[0], te;
      },
      formatter: (I) => d(I, c)
    }),
    [k, l, d, c]
  ), C = F(
    () => i.map(
      (I) => ge(p(s[I] ?? String(I)))
    ),
    [i, s, p]
  ), O = F(
    () => ({
      type: "category",
      axisLine: {
        show: !1
      },
      axisTick: {
        show: !1
      },
      axisLabel: {
        ...k.typography.overlineDelicate,
        padding: [parseInt(k.spacing(0.5)), 0, 0, 0]
      },
      data: C
    }),
    [k, C]
  ), L = F(() => {
    let I = [];
    return y ? I = t.reduce((R, X) => (X.forEach(
      (j, K) => R[K] = (R[K] ?? 0) + (j ?? Number.MIN_SAFE_INTEGER)
    ), R), []) : I = t.flat().map((R) => R ?? Number.MIN_SAFE_INTEGER), Math.max(...I);
  }, [t, y]), P = F(
    () => ({
      type: "value",
      axisLabel: {
        margin: 0,
        verticalAlign: "bottom",
        padding: [0, 0, parseInt(k.spacing(1.25)), 0],
        show: !0,
        showMaxLabel: !0,
        showMinLabel: !1,
        inside: !0,
        color: (I) => I >= L ? k.palette.black[60] : "transparent",
        ...k.typography.overlineDelicate,
        formatter: (I) => ge(c(I))
      },
      axisLine: {
        show: !1
      },
      axisTick: {
        show: !1
      },
      splitLine: {
        show: !0,
        onZero: !1,
        lineStyle: {
          color: k.palette.black[4]
        }
      }
    }),
    [k, L, c]
  ), $ = F(
    () => t.map((I, R) => ({
      type: "bar",
      name: r[R] ?? "",
      animation: w,
      barMaxWidth: 100,
      data: I.map((X, j) => {
        const K = o.some(
          ([Y, Z = 0]) => Y === j && Z === R
        ), te = !!o.length && !K;
        return {
          value: X,
          ...te && {
            itemStyle: { color: k.palette.black[25] },
            disabled: !0
          }
        };
      }),
      ...y && { stack: "total" },
      ...!ji && {
        emphasis: {
          focus: "series",
          itemStyle: {
            color: yt(u[R] ?? "#000", 0.25)
          }
        }
      }
    })),
    [w, u, r, t, o, y, k]
  ), W = F(
    () => ({
      grid: {
        left: C.length >= 4 ? Ft(
          String(C[0]),
          C.length
        ) : 0,
        top: parseInt(k.spacing(2)),
        right: C.length >= 4 ? Ft(
          String(C[C.length - 1]),
          C.length
        ) : 0,
        bottom: 0,
        containLabel: !0
      },
      axisPointer: {
        lineStyle: {
          color: k.palette.black[40]
        }
      },
      color: u,
      tooltip: A,
      xAxis: O,
      yAxis: P,
      series: $
    }),
    [
      C,
      k,
      u,
      A,
      O,
      P,
      $
    ]
  ), J = () => {
    a && a([], []);
  }, G = (I) => {
    I.key === "Enter" && J();
  }, D = oe(
    (I) => {
      if (a) {
        const R = [...o], { dataIndex: X, componentIndex: j } = I, K = R.findIndex(
          ([Y, Z = 0]) => X === Y && j === Z
        );
        K === -1 ? R.push([X, j]) : R.splice(K, 1);
        const te = R.map(
          ([Y, Z = 0]) => ({
            xAxis: i[Y],
            serie: r[Z],
            yAxis: t[Z][Y]
          })
        );
        a(b ? R : R.map((Y) => Y[0]), te);
      }
    },
    [
      t,
      a,
      o,
      i,
      r,
      b
    ]
  ), N = F(
    () => f ? {
      click: D
    } : {},
    [f, D]
  );
  return x ? /* @__PURE__ */ n(zi, { height: g }) : /* @__PURE__ */ v("div", { children: [
    a && /* @__PURE__ */ v(Yi, { container: !0, children: [
      /* @__PURE__ */ n(H, { variant: "caption", children: o.length > 0 ? T.formatMessage(
        { id: "c4r.widgets.bar.selectedItems" },
        { items: o.length }
      ) : T.formatMessage({ id: "c4r.widgets.bar.all" }) }),
      o && o.length > 0 && /* @__PURE__ */ n(
        Vi,
        {
          onClick: () => J(),
          onKeyDown: G,
          underline: "hover",
          tabIndex: 0,
          children: T.formatMessage({ id: "c4r.widgets.bar.clear" })
        }
      )
    ] }),
    !!W && /* @__PURE__ */ n(
      We,
      {
        option: W,
        lazyUpdate: !0,
        notMerge: !0,
        onEvents: N,
        style: { height: g }
      }
    )
  ] });
}
function Ft(e = "", t = 0) {
  return t <= 15 && e.length <= 8 ? 0 : e.length * 8.5 / 6;
}
const Me = "__rest__", Oe = "Others";
var Te = /* @__PURE__ */ ((e) => (e.RANKING = "ranking", e.FIXED = "fixed", e))(Te || {});
const kn = m(ae)(({ theme: e }) => ({
  maxHeight: e.spacing(40),
  overflow: "auto",
  padding: 0
})), Sn = m(ae, {
  shouldForwardProp: (e) => e !== "selectable" && e !== "name" && e !== "unselected"
})(({ theme: e, selectable: t, name: i, unselected: r }) => ({
  flexDirection: "row",
  maxWidth: "100%",
  padding: e.spacing(0.5, 0.25),
  margin: 0,
  "> .MuiGrid-item": {
    paddingTop: 0,
    paddingLeft: 0
  },
  "&:focus-visible": {
    outline: "none !important",
    boxShadow: `inset 0 0 0 2px ${e.palette.primary.main} !important`
  },
  ...r && {
    color: e.palette.text.disabled,
    ".progressbar div": {
      backgroundColor: e.palette.text.disabled
    }
  },
  ...i !== Me && t && {
    cursor: "pointer",
    flexWrap: "nowrap",
    "&:hover .progressbar div": {
      backgroundColor: e.palette.secondary.dark
    }
  },
  ...i === Me && {
    cursor: "default",
    ".progressbar div": {
      backgroundColor: e.palette.text.disabled
    }
  }
})), Nt = m(ae)(
  ({ theme: { spacing: e, palette: t } }) => ({
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: e(1.5),
    paddingRight: e(1),
    "& .MuiTypography-caption": {
      color: t.text.secondary
    }
  })
), Gi = m(ae)(({ theme: e }) => ({
  height: e.spacing(0.5),
  width: "100%",
  margin: e.spacing(0.5, 0, 0.25, 0),
  borderRadius: e.spacing(0.5),
  backgroundColor: e.palette.action.disabledBackground,
  "& div": {
    width: 0,
    height: "100%",
    borderRadius: e.spacing(0.5),
    backgroundColor: e.palette.secondary.main,
    transition: `background-color ${e.transitions.easing.sharp} ${e.transitions.duration.shortest}ms,
                 width ${e.transitions.easing.sharp} ${e.transitions.duration.complex}ms`
  }
})), Ui = m(ae, {
  shouldForwardProp: (e) => e !== "isSelectable"
})(({ theme: e, isSelectable: t }) => ({
  ...t && {
    width: `calc(100% - ${e.spacing(4)})`
  }
})), Xi = m(H)(({ theme: e }) => ({
  fontWeight: e.typography.fontWeightBold,
  marginRight: e.spacing(2)
})), Ve = m(ye)(({ theme: e }) => ({
  ...e.typography.caption,
  cursor: "pointer",
  "& + hr": {
    margin: e.spacing(0, 1)
  }
})), qi = m(S)(({ theme: e }) => ({
  ...e.typography.body2
})), Bt = m($e)(({ theme: e }) => ({
  position: "absolute",
  left: "-999px",
  top: "-1px",
  width: "1px",
  height: "1px",
  display: "inline-flex",
  "&:focus-visible": {
    position: "static",
    width: "auto",
    height: "auto",
    marginTop: e.spacing(2)
  }
})), Ki = m(z)(({ theme: e }) => ({
  marginTop: e.spacing(1.25),
  marginBottom: e.spacing(1.75)
})), Zi = (e) => e % 2 === 1, Mn = () => /* @__PURE__ */ v(ie, { children: [
  /* @__PURE__ */ n(z, { width: 48, height: 8 }),
  /* @__PURE__ */ n(kn, { container: !0, mt: 3, children: [...Array(6)].map((e, t) => /* @__PURE__ */ v(Sn, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ v(ae, { container: !0, item: !0, direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ n(z, { width: Zi(t) ? 72 : 48, height: 8 }),
      /* @__PURE__ */ n(z, { width: 48, height: 8 })
    ] }),
    /* @__PURE__ */ n(Ki, { height: 4, width: "100%" })
  ] }, t)) })
] });
function In(e) {
  const t = re();
  return U(() => {
    t.current = e;
  }), t.current;
}
function gt({
  start: e,
  end: t,
  duration: i,
  drawFrame: r,
  requestRef: o
}) {
  if (e === t && !(e === 0 && t === 0))
    return;
  const l = t - e;
  let d = e;
  const s = l / (i / 1e3 * 60), u = () => {
    d += s, r(Math.floor(d)), s > 0 && d < t || s < 0 && d > t ? o.current = requestAnimationFrame(u) : r(t);
  };
  o.current = requestAnimationFrame(u);
}
function Ji({
  start: e,
  end: t,
  duration: i,
  drawFrame: r,
  requestRef: o
}) {
  if (e.length === t.length && e.every((g, f) => g.value === t[f].value))
    return;
  let l = t.map(
    (g, f) => e[f] && e[f].name === g.name ? { ...g, value: e[f].value } : g
  ), d = 0;
  const s = l.map((g, f) => t[f].value - g.value);
  if (s.every((g) => g === 0)) {
    r(t);
    return;
  }
  const p = i / 1e3 * 60, c = s.map((g) => g / p), y = () => {
    d < p ? (l = l.map((g, f) => {
      const w = Math.floor(g.value + c[f]), h = f > 0 && Math.floor(g.value + c[f - 1]);
      return {
        ...g,
        value: w === h ? t[f].value : w
      };
    }), r(l), d++, o.current = requestAnimationFrame(y)) : r(t);
  };
  o.current = requestAnimationFrame(y);
}
const Qi = [], er = {}, tr = (e) => e, ct = () => {
}, nr = (e) => e.reduce((t, i) => t + (i.value ?? 0), 0);
function rs({
  data: e,
  formatter: t = tr,
  labels: i = er,
  maxItems: r = 5,
  order: o = Te.RANKING,
  selectedCategories: a = Qi,
  onSelectedCategoriesChange: l = ct,
  onMaxItemsOverflow: d = nr,
  animation: s = !0,
  filterable: u = !0,
  searchable: p = !0,
  isLoading: c
}) {
  const y = le(), [g, f] = _([]), [w, h] = _(1), [b, k] = _(!1), [M, T] = _(""), [x, A] = _([]), [C, O] = _(
    []
  ), [L, P] = _([]), $ = re(null), W = re(), J = In(L), G = re([]), { showSkeleton: D } = ke(!!c), N = se(), I = ce(N);
  function R(E) {
    return g.reduce((q, Q) => (E.includes(Q.name) && q.push(Q.name), q), []);
  }
  function X(E) {
    if (E !== Me) {
      let q;
      a.includes(E) ? q = a.filter((Q) => Q !== E) : q = [...a, E], l && l(q);
    }
  }
  const j = () => l([]), K = (E) => {
    E.key === "Enter" && j();
  }, te = () => {
    l([]), A([]);
  }, Y = (E) => {
    E.key === "Enter" && te();
  }, Z = () => {
    A(R(a));
  }, de = (E) => {
    E.key === "Enter" && Z();
  }, we = () => {
    const E = R(
      C
    );
    l([...E]), A([...E]), O([]), k(!1), T("");
  }, ve = (E) => {
    E.key === "Enter" && we();
  }, V = () => {
    T(""), k(!1);
  }, ee = (E) => {
    if (E !== Me) {
      let q;
      C.includes(E) ? q = C.filter((Q) => Q !== E) : q = [...C, E], O(q);
    }
  }, ne = (E) => {
    E.currentTarget.scrollIntoView();
  }, pe = (E) => {
    T(E.currentTarget.value);
  }, Ce = () => {
    k(!0), O([...a]);
  }, Re = oe(
    (E) => {
      if (b)
        return M ? E.filter((q) => {
          var xe;
          if (!q.name)
            return !1;
          const Q = String(q.name);
          return !!(Q.toLowerCase().includes(M.toLowerCase()) || (xe = i[Q]) != null && xe.toLowerCase().includes(M.toLowerCase()));
        }) : E;
      if (x.length)
        return x.reduce((Q, xe) => {
          const Ye = E.find((be) => be.name === xe);
          return Q.push({
            name: xe,
            value: Ye ? Ye.value : null
          }), Q;
        }, []);
      {
        const q = E.slice(0, r);
        if (q.length < E.length) {
          const Q = {
            name: Me,
            value: d(E.slice(r))
          };
          return [...q, Q];
        } else
          return q;
      }
    },
    [
      x,
      i,
      r,
      M,
      b,
      d
    ]
  ), Ae = oe(() => {
    const E = x.length;
    return E ? e.length - E : e.length - r;
  }, [e, r, x]), Dt = oe(
    (E) => E === Me ? `Others ${p ? "" : `(${Ae()})`}` : i[String(E)] ?? String(E),
    [Ae, i, p]
  ), Un = oe(
    (E) => E >= w ? E != null ? "100%" : 0 : `${(E || 0) * 100 / w}%`,
    [w]
  );
  U(() => {
    a.length === 0 && A([]);
  }, [a]), U(() => {
    if (e) {
      if (o === Te.RANKING) {
        const E = [...e].sort((Q, xe) => (xe.value ?? 0) - (Q.value ?? 0)), q = Re(E);
        q.length > 0 ? h(q[0].value ?? 0) : h(1), f(q);
      } else if (o === Te.FIXED) {
        h(Math.max(...e.map((q) => q.value ?? 0)));
        const E = Re(e);
        f(E);
      }
    }
  }, [
    x,
    Re,
    e,
    i,
    r,
    o,
    M,
    b
  ]), U(() => {
    J && (G.current = J);
  }, [J]), U(() => {
    if (s)
      return Ji({
        start: (G.current || []).map((E) => ({
          ...E,
          value: E.value ?? 0
        })),
        end: g.map((E) => ({ ...E, value: E.value ?? 0 })),
        duration: 500,
        drawFrame: (E) => P(E),
        requestRef: $
      }), () => {
        $.current && cancelAnimationFrame($.current);
      };
    P(g);
  }, [s, g]), U(() => {
    b && W.current && W.current.focus();
  }, [b, W]);
  function Xn({
    data: E,
    onCategoryClick: q
  }) {
    const Q = t(E.value ?? 0), [xe, Ye] = _(!1), be = re(null), lt = () => {
      var $t, Pt;
      const st = ((($t = be == null ? void 0 : be.current) == null ? void 0 : $t.scrollWidth) ?? 0) > (((Pt = be == null ? void 0 : be.current) == null ? void 0 : Pt.clientWidth) ?? 0);
      Ye(st);
    };
    U(() => (lt(), window.addEventListener("resize", lt), () => {
      window.removeEventListener("resize", lt);
    }), []);
    const Zn = (st) => {
      st.key === "Enter" && q();
    }, Jn = !b && a.length > 0 && !a.includes(E.name);
    return /* @__PURE__ */ v(
      Sn,
      {
        container: !0,
        direction: "row",
        spacing: 1,
        onClick: u ? q : ct,
        onKeyDown: u ? Zn : ct,
        selectable: u,
        unselected: Jn,
        name: E.name === Me ? Me : "",
        tabIndex: u ? 0 : -1,
        children: [
          u && b && /* @__PURE__ */ n(ae, { item: !0, mr: 1, children: /* @__PURE__ */ n(
            ln,
            {
              checked: C.includes(E.name),
              tabIndex: -1
            }
          ) }),
          /* @__PURE__ */ v(Ui, { container: !0, item: !0, xs: !0, isSelectable: b, children: [
            /* @__PURE__ */ v(
              ae,
              {
                container: !0,
                item: !0,
                direction: "row",
                justifyContent: "space-between",
                wrap: "nowrap",
                children: [
                  /* @__PURE__ */ n(
                    ue,
                    {
                      title: Dt(E.name),
                      disableHoverListener: !xe,
                      children: /* @__PURE__ */ n(Xi, { variant: "body2", noWrap: !0, ref: be, children: Dt(E.name) })
                    }
                  ),
                  typeof Q == "object" && Q !== null ? /* @__PURE__ */ v("span", { children: [
                    Q.prefix,
                    Q.value,
                    Q.suffix
                  ] }) : /* @__PURE__ */ n("span", { children: Q })
                ]
              }
            ),
            /* @__PURE__ */ n(Gi, { className: "progressbar", item: !0, children: /* @__PURE__ */ n("div", { style: { width: Un(E.value ?? 0) } }) })
          ] })
        ]
      }
    );
  }
  if ((e == null ? void 0 : e.length) === 0 || D) return /* @__PURE__ */ n(Mn, {});
  const qn = ({
    index: E,
    style: q
  }) => {
    const Q = L[E];
    return Q ? /* @__PURE__ */ n("div", { style: q, children: /* @__PURE__ */ n(
      Xn,
      {
        data: Q,
        onCategoryClick: () => b ? ee(Q.name) : X(Q.name)
      }
    ) }) : null;
  }, Kn = () => b ? 320 : L.length <= r ? L.length * 38 : x.length > 0 ? x.length * 38 : (r + 1) * 38;
  return /* @__PURE__ */ v(qi, { children: [
    u && g.length > 0 && /* @__PURE__ */ v(Nt, { container: !0, children: [
      /* @__PURE__ */ n(H, { variant: "caption", children: a.length > 0 ? I.formatMessage(
        { id: "c4r.widgets.category.selectedItems" },
        { items: a.length }
      ) : I.formatMessage({ id: "c4r.widgets.category.all" }) }),
      b ? /* @__PURE__ */ n(
        Ve,
        {
          onClick: we,
          onKeyDown: ve,
          underline: "hover",
          tabIndex: 0,
          "data-testid": "primaryApplyButton",
          children: I.formatMessage({ id: "c4r.widgets.category.apply" })
        }
      ) : x.length > 0 ? /* @__PURE__ */ n(
        Ve,
        {
          onClick: te,
          onKeyDown: Y,
          underline: "hover",
          tabIndex: 0,
          children: I.formatMessage({ id: "c4r.widgets.category.unlock" })
        }
      ) : a.length > 0 && /* @__PURE__ */ v(ae, { container: !0, direction: "row", justifyContent: "flex-end", item: !0, xs: !0, children: [
        /* @__PURE__ */ n(
          Ve,
          {
            onClick: Z,
            onKeyDown: de,
            underline: "hover",
            tabIndex: 0,
            children: I.formatMessage({
              id: "c4r.widgets.category.lock"
            })
          }
        ),
        /* @__PURE__ */ n(wt, { orientation: "vertical", flexItem: !0 }),
        /* @__PURE__ */ n(
          Ve,
          {
            onClick: j,
            onKeyDown: K,
            underline: "hover",
            tabIndex: 0,
            children: I.formatMessage({
              id: "c4r.widgets.category.clear"
            })
          }
        )
      ] })
    ] }),
    e.length > r && b && /* @__PURE__ */ v(Nt, { container: !0, children: [
      /* @__PURE__ */ n(
        ot,
        {
          size: "small",
          sx: { mt: -0.5 },
          placeholder: I.formatMessage({
            id: "c4r.widgets.category.search"
          }),
          onChange: pe,
          onFocus: ne,
          InputProps: {
            startAdornment: /* @__PURE__ */ n(vt, { position: "start", children: /* @__PURE__ */ n(Qe, {}) })
          },
          inputProps: {
            tabIndex: 0,
            ref: W
          }
        }
      ),
      /* @__PURE__ */ n(Bt, { size: "small", onClick: V, children: I.formatMessage({ id: "c4r.widgets.category.cancel" }) })
    ] }),
    /* @__PURE__ */ n(kn, { container: !0, item: !0, children: L.length ? /* @__PURE__ */ n(
      bi,
      {
        outerElementType: ei(
          (E, q) => /* @__PURE__ */ n("div", { ref: q, "data-testid": "category-widget-list", ...E })
        ),
        height: Kn(),
        width: "100%",
        itemCount: L.length,
        itemSize: y.spacingValue * 4.5,
        children: qn
      }
    ) : /* @__PURE__ */ v(S, { children: [
      /* @__PURE__ */ n(H, { variant: "body2", children: I.formatMessage({
        id: "c4r.widgets.category.noResults"
      }) }),
      /* @__PURE__ */ n(H, { component: "p", variant: "caption", mb: 2, children: I.formatMessage(
        { id: "c4r.widgets.category.noResultsMessage" },
        { searchValue: M }
      ) })
    ] }) }),
    b && /* @__PURE__ */ n(Bt, { size: "small", onClick: we, children: I.formatMessage({ id: "c4r.widgets.category.apply" }) }),
    e.length > r && p ? b ? /* @__PURE__ */ n(S, { mt: 1.5, children: /* @__PURE__ */ n(
      $e,
      {
        size: "small",
        color: "primary",
        onClick: V,
        "data-testid": "primaryCancelButton",
        children: I.formatMessage({ id: "c4r.widgets.category.cancel" })
      }
    ) }) : /* @__PURE__ */ n(S, { mt: 1.5, children: /* @__PURE__ */ n(
      $e,
      {
        "data-testid": "show-all-categories-button",
        size: "small",
        color: "primary",
        startIcon: /* @__PURE__ */ n(Qe, {}),
        onClick: Ce,
        children: I.formatMessage(
          { id: "c4r.widgets.category.searchInfo" },
          { elements: Ae() }
        )
      }
    ) }) : null
  ] });
}
const Tn = () => /* @__PURE__ */ n(S, { pt: 0.5, children: /* @__PURE__ */ n(z, { height: 24, width: 120 }) }), ir = m("span")(() => ({
  marginRight: "2px"
})), rr = m("span")(() => ({
  marginLeft: "2px"
})), Ge = "-", or = (e) => e;
function os({
  data: e = Ge,
  formatter: t = or,
  animation: i = !0,
  isLoading: r = !1
}) {
  const [o, a] = _(Ge), l = re(null), d = In(o), s = re(d), { showSkeleton: u } = ke(!!r);
  U(() => (typeof e == "number" && i ? gt({
    start: s.current || 0,
    end: e,
    duration: 500,
    drawFrame: (g) => a(g),
    requestRef: l
  }) : typeof e == "object" && i && e && s.current && e.value !== null && e.value !== void 0 ? gt({
    start: Number(
      s.current.value
    ),
    end: Number(e.value),
    duration: 1e3,
    drawFrame: (g) => a({ value: g, prefix: e.prefix, suffix: e.suffix }),
    requestRef: l
  }) : a(e ?? Ge), () => {
    l.current && cancelAnimationFrame(l.current);
  }), [i, e, a]);
  const p = t(o), c = typeof p == "object" && p !== null, y = p === Ge;
  return u ? /* @__PURE__ */ n(Tn, {}) : c ? /* @__PURE__ */ v(H, { variant: "h5", component: "div", weight: "medium", children: [
    /* @__PURE__ */ n(ir, { children: p.prefix }),
    p.value,
    /* @__PURE__ */ n(rr, { children: p.suffix })
  ] }) : /* @__PURE__ */ n(
    H,
    {
      variant: "h5",
      component: "div",
      weight: "medium",
      color: y ? "text.disabled" : "default",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      children: p
    }
  );
}
const _t = {};
let Ne = null;
function ar({
  data: e,
  filterable: t,
  selectedBars: i,
  onSelectedBarsChange: r,
  echartsInstance: o
}) {
  const a = le(), [l, d] = _([]), s = F(() => o == null ? void 0 : o.getZr(), [o]);
  U(() => {
    function p(y) {
      if (o) {
        const [g] = o.convertFromPixel({ seriesIndex: 0 }, [
          y.offsetX,
          y.offsetY
        ]);
        Ne = g ?? null;
      }
    }
    function c(y) {
      if (o && Ne !== null) {
        const [g] = o.convertFromPixel({ seriesIndex: 0 }, [
          y.offsetX,
          y.offsetY
        ]);
        d(Ne === g ? [] : [Ne, g].sort((f, w) => f - w));
      }
    }
    if (o && t) {
      const y = dt(
        s,
        "mousedown",
        p
      ), g = dt(
        s,
        "mousemove",
        c
      );
      return () => {
        y == null || y(), g == null || g();
      };
    }
  }, [s, o, t]), U(() => {
    function p() {
      if (l.length === 2 && r) {
        const c = e.reduce((y, g, f) => ((l[0] >= g[0] && l[0] <= g[1] || l[1] >= g[0] && l[1] <= g[1] || l[0] <= g[0] && l[1] >= g[1]) && y.push(f), y), []);
        r(
          e.length === c.length ? [] : c
        );
      }
      d([]), Ne = null;
    }
    if (o && t)
      return dt(s, "mouseup", p);
  }, [s, o, l, e, r, t]);
  const u = oe(
    (p) => {
      if (r) {
        const c = new Set(i);
        c.has(p.dataIndex) ? c.delete(p.dataIndex) : c.add(p.dataIndex), r(
          c.size === e.length ? [] : Array.from(c)
        );
      }
    },
    [r, i, e.length]
  );
  return {
    markAreaOptions: l.length === 2 && {
      data: [[{ coord: [l[0]] }, { coord: [l[1]] }]],
      itemStyle: {
        color: a.palette.primary.main,
        opacity: 0.2
      }
    },
    onEvents: t ? { click: u } : {}
  };
}
function dt(e, t, i) {
  if (e != null && e.handler)
    return _t[t] = i, e.on(t, i), () => {
      _t[t] && (e != null && e.handler) && e.off(t, i);
    };
}
function lr({ height: e }) {
  return /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(S, { mb: 2, children: /* @__PURE__ */ n(z, { width: 48, height: 8 }) }),
    /* @__PURE__ */ v(bn, { style: { height: e ?? at }, children: [
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "20%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "40%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "60%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "20%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "80%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "50%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "20%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "40%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "60%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "20%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "80%" }),
      /* @__PURE__ */ n(he, { variant: "rectangular", height: "50%" })
    ] })
  ] });
}
const sr = vn(), cr = m(ae)(({ theme: e }) => ({
  marginBottom: e.spacing(2),
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  "& .MuiTypography-caption": {
    color: e.palette.text.secondary
  }
})), dr = m(ye)(({ theme: e }) => ({
  ...e.typography.caption,
  cursor: "pointer"
})), ur = [], pr = () => {
}, et = (e) => e;
function gr(e, t = et, i = et) {
  if (!e)
    return null;
  if (Array.isArray(e) && e.length === 0)
    return;
  const r = Array.isArray(e) ? e[0].marker : e.marker, o = Array.isArray(e) ? e[0].data : e.data;
  if ((o == null ? void 0 : o.value) === void 0)
    return;
  const [a, l, d] = o.value, s = ge(t(a)), u = ge(t(l)), p = ge(i(d)), c = `${s} <span style="vertical-align: 1px;">—</span> ${u}`, y = `<div style="margin-left: 8px; display: inline">${p}</div>`;
  return `${c} <div style="margin-top: 4px">${String(r)}${y}</div>`;
}
function as({
  data: e,
  ticks: t,
  min: i,
  max: r,
  xAxisFormatter: o = et,
  yAxisFormatter: a = et,
  yAxisType: l = "dense",
  selectedBars: d = ur,
  onSelectedBarsChange: s = pr,
  tooltip: u = !0,
  tooltipFormatter: p = gr,
  animation: c = !0,
  filterable: y = !0,
  height: g = 200,
  isLoading: f
}) {
  const w = se(), h = le(), b = ce(w), { showSkeleton: k } = ke(!!f), M = !!y && !!s, [T, x] = _(), A = (I) => x(I), C = F(
    () => mr(e, t, i, r),
    [e, t, i, r]
  ), { onEvents: O, markAreaOptions: L } = ar({
    data: C,
    filterable: M,
    selectedBars: d,
    onSelectedBarsChange: s,
    echartsInstance: T
  }), P = F(
    () => ({
      show: u,
      trigger: "item",
      padding: [B * 0.5, B],
      borderWidth: 0,
      textStyle: {
        ...h.typography.caption,
        fontSize: 11,
        color: h.palette.common.white
      },
      backgroundColor: h.palette.black[90],
      confine: !0,
      position: "top",
      formatter(I) {
        return p(I, o, a);
      }
    }),
    [h, u, p, o, a]
  ), $ = F(
    () => ({
      min: i,
      max: r,
      interval: (r - i) / C.length,
      axisLine: {
        show: !1
      },
      splitLine: {
        show: !0,
        lineStyle: {
          color: h.palette.black[4]
        }
      },
      axisTick: {
        show: !1
      },
      axisLabel: {
        showMinLabel: !0,
        showMaxLabel: !0,
        ...h.typography.overlineDelicate,
        hideOverlap: !0,
        padding: [B * 0.5, B * 0.5, 0, B * 0.5],
        formatter: (I) => {
          const R = ge(o(I));
          return I === i ? hr(R) : I === r ? fr(R) : R;
        },
        color: h.palette.black[60]
      }
    }),
    [i, r, C.length, h, o]
  ), W = F(() => {
    const I = {
      margin: 0,
      verticalAlign: "bottom",
      padding: [0, 0, B * 1.25, 0],
      inside: !0,
      color: (j) => {
        const K = Math.max(...e.map((Y) => Y ?? Number.MIN_SAFE_INTEGER)) || 1;
        let te = "transparent";
        return j >= K && (te = h.palette.black[60]), te;
      },
      ...h.typography.overlineDelicate,
      formatter: (j) => ge(a(j))
    }, R = {
      verticalAlign: "middle",
      padding: [0, 0, 0, B * 0.5],
      color: h.palette.black[60]
    }, X = l === "dense" ? I : R;
    return {
      type: "value",
      axisLine: {
        show: !1
      },
      splitLine: {
        show: !0,
        lineStyle: {
          color: h.palette.black[4]
        }
      },
      axisTick: {
        show: !1
      },
      axisLabel: {
        show: !0,
        showMaxLabel: !0,
        showMinLabel: !1,
        ...X,
        ...h.typography.overlineDelicate,
        formatter: (j) => ge(a(j))
      }
    };
  }, [
    h.palette.black,
    h.typography.overlineDelicate,
    e,
    a,
    l
  ]), J = F(() => {
    const I = i === r && C.filter((j) => j[2] !== 0).length === 1, X = (I ? [C[0], C[C.length - 1]] : C).map((j, K) => {
      const Y = d.length && !d.includes(K) ? h.palette.black[25] : h.palette.secondary.main;
      return { value: j, itemStyle: { color: Y } };
    });
    return {
      type: "custom",
      cursor: "pointer",
      markArea: L,
      renderItem: function(j, K) {
        const te = j.dataIndex === C.length - 1, Y = j.dataIndex === 0, Z = X[j.dataIndex].itemStyle.color, de = K.value(0), we = K.value(1), ve = K.value(2), [V, ee] = K.coord([de, ve]), [ne, pe] = K.size([we - de, ve]);
        return {
          type: "rect",
          shape: {
            x: I ? V / 10 : V + (Y ? 0 : 1),
            y: ee,
            // Division by 10 in the next line is done to avoid that the only bar rendered inside the histogram widget gets all the width of it
            width: I ? V - V / 10 : ne - (te ? 0 : 1),
            height: pe
          },
          style: { fill: Z },
          ...!sr && {
            emphasis: {
              style: {
                fill: yt(Z, 0.25)
              }
            }
          }
        };
      },
      encode: {
        x: [0, 1],
        y: 2,
        tooltip: [0, 1, 2]
      },
      data: X,
      animation: c
    };
  }, [
    i,
    r,
    C,
    L,
    h.palette.black,
    h.palette.secondary.main,
    d,
    c
  ]), G = F(
    () => ({
      grid: {
        left: B * 0.1,
        right: B * 0.1,
        top: B * 2,
        bottom: B * 0.5,
        containLabel: !0
      },
      tooltip: P,
      xAxis: $,
      yAxis: W,
      series: [J]
    }),
    [P, $, W, J]
  ), D = d.reduce(
    (I, R) => I += e[R] ?? 0,
    0
  ), N = (I) => {
    I.key === "Enter" && s([]);
  };
  return k ? /* @__PURE__ */ n(lr, { height: g }) : /* @__PURE__ */ v("div", { children: [
    M && /* @__PURE__ */ v(cr, { container: !0, children: [
      /* @__PURE__ */ n(H, { variant: "caption", weight: "strong", children: d.length > 0 ? b.formatMessage(
        { id: "c4r.widgets.histogram.selectedItems" },
        {
          items: ge(
            a(D)
          )
        }
      ) : b.formatMessage({ id: "c4r.widgets.histogram.all" }) }),
      d.length > 0 && /* @__PURE__ */ n(
        dr,
        {
          onClick: () => s([]),
          onKeyDown: N,
          underline: "hover",
          tabIndex: 0,
          children: b.formatMessage({ id: "c4r.widgets.histogram.clear" })
        }
      )
    ] }),
    /* @__PURE__ */ n(
      We,
      {
        option: G,
        onEvents: O,
        lazyUpdate: !0,
        onChartReady: A,
        style: { maxHeight: g }
      }
    )
  ] });
}
function hr(e) {
  return `${Array(String(e).length).fill("  ").join("")}${e}`;
}
function fr(e) {
  const t = Array(String(e).length).fill("  ").join("");
  return `${e}${t}`;
}
function mr(e, t, i, r) {
  return e.map(
    (o, a) => [
      a === 0 ? i : t[a - 1],
      a === e.length - 1 ? r : t[a],
      o
    ]
  );
}
function yr(e, t, i, r) {
  const o = le(), a = F(() => t === Te.RANKING ? e.slice().sort((s, u) => (u.value ?? 0) - (s.value ?? 0)) : e, [e, t]), l = F(() => {
    const s = [];
    let u = 0;
    for (const p of a)
      s.length < i ? s.push({ ...p }) : u += p.value ?? 0;
    return u > 0 && s.push({
      name: Oe,
      value: u,
      emphasis: { scale: !1 }
    }), s;
  }, [i, a]);
  return F(() => {
    const s = o.palette.common.white;
    return l.map((u, p) => {
      let c = s;
      if (r.length) {
        const g = r[p % r.length];
        g && (c = g);
      } else {
        const f = o.palette.qualitative.bold[p];
        f && (c = f);
      }
      const y = u;
      return y.color = c, y;
    });
  }, [l, r, o]);
}
const wr = m(S)(({ theme: e }) => ({
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: e.spacing(1)
})), vr = m(S)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  maxWidth: "140px",
  textTransform: "uppercase"
})), xr = m(S)(({ theme: e }) => ({
  display: "inline-block",
  borderRadius: e.spacing(0.5),
  width: e.spacing(1),
  minWidth: e.spacing(1),
  height: e.spacing(1)
}));
function br({
  data: e,
  selectedCategories: t,
  formatter: i
}) {
  const [r, o] = _(), a = F(() => {
    if (!e || e.length === 0)
      return null;
    let u;
    t.length > 0 ? u = e.filter(
      (f) => t.includes(f.name)
    ) : u = e;
    const p = kr(u), c = u.find((f) => f === p);
    if (!c)
      return null;
    let y = 0;
    for (const f of e)
      y += f.value ?? 0;
    const g = Sr(
      c.value ?? 0,
      y,
      i
    );
    return { ...c, percentage: g };
  }, [e, t, i]);
  U(() => {
    a && o(a);
  }, [a, o]);
  const { name: l, percentage: d, color: s } = r ?? {};
  return r ? /* @__PURE__ */ v(wr, { children: [
    /* @__PURE__ */ n(H, { variant: "h5", children: d }),
    /* @__PURE__ */ v(vr, { children: [
      /* @__PURE__ */ n(xr, { bgcolor: s, component: "span" }),
      /* @__PURE__ */ n(H, { component: "span", variant: "body2", noWrap: !0, children: l })
    ] })
  ] }) : null;
}
function kr(e) {
  const t = e.filter(
    (i) => i.name !== Oe
  );
  return t.length === 0 ? e[0] : t.reduce((i, r) => (r.value ?? 0) > (i.value ?? 0) ? r : i);
}
function Sr(e, t, i) {
  let r = 0;
  return t !== 0 && (r = e / t * 100), i ? i(r) : `${r}%`;
}
const Ht = 32, Mr = m(S)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: e.spacing(0.5)
})), Ir = m("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative"
})), Tr = m(Hi)(() => ({
  position: "absolute",
  zIndex: 1
})), Cr = m("div")(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: e.spacing(1),
  position: "absolute",
  zIndex: 2
})), Ar = m(S)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(2),
  height: e.spacing(5)
})), Er = m("div")(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1.5)
}));
function Cn({ height: e }) {
  const t = parseInt(String(e), 10) || at, i = t - Ht, r = i - Ht;
  return /* @__PURE__ */ v(S, { mt: 0.5, children: [
    /* @__PURE__ */ n(z, { height: 8, width: 64 }),
    /* @__PURE__ */ n(Mr, { height: t, children: /* @__PURE__ */ v(Ir, { children: [
      /* @__PURE__ */ n(z, { variant: "circular", width: i, height: i }),
      /* @__PURE__ */ n(
        Tr,
        {
          variant: "circular",
          width: r,
          height: r
        }
      ),
      /* @__PURE__ */ v(Cr, { children: [
        /* @__PURE__ */ n(z, { height: 24, width: 72 }),
        /* @__PURE__ */ n(z, { height: 8, width: 48 })
      ] })
    ] }) }),
    /* @__PURE__ */ n(Ar, { children: [...Array(2)].map((o, a) => /* @__PURE__ */ v(Er, { children: [
      /* @__PURE__ */ n(z, { variant: "circular", width: 8, height: 8 }),
      /* @__PURE__ */ n(z, { width: 48, height: 8 })
    ] }, a)) })
  ] });
}
const Lr = m(S)(({ theme: e }) => ({
  position: "relative",
  padding: e.spacing(1.25, 1, 0, 1),
  width: "100%"
})), Dr = m(S)(({ theme: e }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  overflowX: "hidden",
  gap: e.spacing(2),
  // Accessibility tweak to display focus indicator properly
  padding: e.spacing(0.5),
  margin: e.spacing(-0.5)
})), $r = m(S)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  gap: e.spacing(1),
  alignItems: "center",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  cursor: "pointer"
})), Pr = m(S)(({ theme: e }) => ({
  display: "inline-block",
  position: "absolute",
  left: e.spacing(-2),
  top: e.spacing(1),
  bottom: e.spacing(1),
  zIndex: 1,
  width: e.spacing(2.5),
  background: `linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, ${e.palette.background.paper} 100%)`
})), Or = m(S)(({ theme: e }) => ({
  position: "absolute",
  padding: e.spacing(0.25, 1),
  top: e.spacing(0),
  right: 0,
  background: e.palette.background.paper
})), Wr = m(S, {
  shouldForwardProp: (e) => e !== "color"
})(({ theme: e, color: t }) => {
  const i = e.spacing(1);
  return {
    backgroundColor: t,
    borderRadius: "50%",
    width: i,
    height: i
  };
});
function An({
  series: e,
  selectedCategories: t,
  onCategoryClick: i
}) {
  var M, T;
  const r = le(), [o, a] = _(!1), [l, d] = _(0), [s, u] = _(void 0), p = re(null), c = re(null), y = re(null), g = se(), f = ce(g);
  function w() {
    d(l + 1);
  }
  function h() {
    d(Math.max(l - 1));
  }
  function b(x, A) {
    x.key === "Enter" && (i == null || i(A));
  }
  const k = oe(() => {
    var A, C, O;
    const x = !!c.current && c.current.scrollWidth > c.current.clientWidth;
    a(x), u(
      x && c.current ? (((A = p.current) == null ? void 0 : A.clientWidth) ?? 0) - (((C = y.current) == null ? void 0 : C.clientWidth) ?? 70) : (((O = p.current) == null ? void 0 : O.clientWidth) ?? 0) - 12 || 500
    );
  }, [p, c, y]);
  return U(() => {
    k();
  }, [
    c,
    (M = c.current) == null ? void 0 : M.scrollWidth,
    (T = c.current) == null ? void 0 : T.clientWidth,
    k,
    l
  ]), U(() => {
    if (typeof ResizeObserver > "u")
      return;
    let x;
    return p.current && (x = new ResizeObserver(() => {
      k();
    }), x.observe(p.current)), () => {
      x == null || x.disconnect();
    };
  }, [p, k]), /* @__PURE__ */ v(Lr, { ref: p, children: [
    /* @__PURE__ */ n(
      Dr,
      {
        ref: c,
        style: {
          maxWidth: `${s}px`
        },
        children: e.map((x, A) => {
          if (A < l) return null;
          const C = t.length === 0 || t.includes(x.name);
          return /* @__PURE__ */ v(
            $r,
            {
              tabIndex: 0,
              onClick: i ? () => i(x.name) : void 0,
              onKeyDown: i ? (O) => b(O, x.name) : void 0,
              style: {
                pointerEvents: !i || x.name === "Others" ? "none" : void 0
              },
              children: [
                /* @__PURE__ */ n(
                  Wr,
                  {
                    color: C ? x.color : r.palette.text.disabled
                  }
                ),
                /* @__PURE__ */ n(
                  H,
                  {
                    variant: "overline",
                    color: C ? void 0 : "text.disabled",
                    children: x.name
                  }
                )
              ]
            },
            A
          );
        })
      }
    ),
    (o || l > 0) && /* @__PURE__ */ v(Or, { ref: y, children: [
      /* @__PURE__ */ n(Pr, {}),
      /* @__PURE__ */ n(
        ue,
        {
          title: f.formatMessage({
            id: "c4r.widgets.chartLegend.next"
          }),
          children: /* @__PURE__ */ n(
            fe,
            {
              size: "small",
              disabled: l === 0,
              onClick: h,
              children: /* @__PURE__ */ n(Si, {})
            }
          )
        }
      ),
      /* @__PURE__ */ n(
        ue,
        {
          title: f.formatMessage({
            id: "c4r.widgets.chartLegend.prev"
          }),
          children: /* @__PURE__ */ n(
            fe,
            {
              size: "small",
              disabled: !o,
              onClick: w,
              children: /* @__PURE__ */ n(Mi, {})
            }
          )
        }
      )
    ] })
  ] });
}
const ht = "232px", Rr = m(ae)(({ theme: e }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: e.spacing(0.5)
})), Fr = m(S, {
  shouldForwardProp: (e) => e !== "height" && e !== "width"
})(
  ({ height: e, width: t }) => ({
    position: "relative",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: t || "100%",
    height: e || "100%"
  })
), Nr = m(We)(() => ({
  position: "absolute",
  top: 0,
  right: 0,
  left: 0,
  bottom: 0
})), zt = [], Br = {}, _r = (e) => e;
function ls({
  name: e,
  data: t,
  formatter: i = _r,
  tooltipFormatter: r = Hr,
  percentFormatter: o,
  height: a = ht,
  width: l = ht,
  labels: d = Br,
  colors: s = zt,
  animation: u = !0,
  filterable: p = !0,
  selectedCategories: c = zt,
  onSelectedCategoriesChange: y,
  isLoading: g,
  maxItems: f = 11,
  order: w = Te.RANKING
}) {
  const h = le(), b = yr(t, w, f, s), { showSkeleton: k } = ke(!!g), M = se(), T = ce(M), x = F(() => o || ((G) => `${M.formatNumber(G, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  })}%`), [M, o]), A = F(() => {
    let G;
    return r && (G = (D) => r(D, i, x)), {
      padding: [B * 0.5, B],
      backgroundColor: h.palette.black[90],
      borderColor: "transparent",
      textStyle: { color: h.palette.common.white },
      confine: !0,
      formatter: G
    };
  }, [
    h.palette.black,
    h.palette.common.white,
    r,
    i,
    x
  ]), C = F(
    () => [
      {
        type: "pie",
        name: e,
        animation: u,
        data: b.map((G) => {
          const D = { ...G }, N = (c == null ? void 0 : c.length) && !c.includes(D.name);
          return d != null && d[D.name] && (D.name = d[D.name]), N ? {
            ...D,
            disabled: !0,
            itemStyle: { color: h.palette.black[25] }
          } : {
            ...D,
            itemStyle: { color: D.color }
          };
        }),
        radius: ["74%", "90%"],
        selectedOffset: 0,
        bottom: B * 1.5,
        label: { show: !1 },
        emphasis: {
          focus: "series",
          scaleSize: 5
        },
        itemStyle: {
          borderColor: h.palette.background.paper,
          borderWidth: 1
        }
      }
    ],
    [e, u, b, d, c, h]
  ), O = F(
    () => ({
      grid: {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      },
      tooltip: A,
      legend: {
        show: !1
      },
      series: C
    }),
    [A, C]
  ), L = oe(
    (G) => {
      if (y) {
        const D = [...c], { name: N } = b[G.dataIndex];
        if (N === Oe)
          return;
        const I = D.indexOf(N);
        I === -1 ? D.push(N) : D.splice(I, 1), y(D);
      }
    },
    [b, y, c]
  ), P = oe(
    (G) => {
      if (y) {
        const D = [...c], N = D.indexOf(G);
        N === -1 ? D.push(G) : D.splice(N, 1), y(D);
      }
    },
    [y, c]
  ), $ = {
    ...p && { click: L }
  }, W = () => {
    y == null || y([]);
  }, J = (G) => {
    G.key === "Enter" && W();
  };
  return k ? /* @__PURE__ */ n(Cn, { height: a }) : /* @__PURE__ */ v(ie, { children: [
    p && /* @__PURE__ */ v(Rr, { container: !0, children: [
      /* @__PURE__ */ n(H, { variant: "caption", color: "textSecondary", children: c.length ? T.formatMessage(
        { id: "c4r.widgets.pie.selectedItems" },
        { items: c.length }
      ) : T.formatMessage({ id: "c4r.widgets.pie.allSelected" }) }),
      c.length > 0 && /* @__PURE__ */ n(
        ye,
        {
          variant: "caption",
          onClick: W,
          onKeyDown: J,
          tabIndex: 0,
          children: T.formatMessage({ id: "c4r.widgets.pie.clear" })
        }
      )
    ] }),
    /* @__PURE__ */ v(Fr, { height: a, width: l, children: [
      /* @__PURE__ */ n(
        br,
        {
          data: b,
          selectedCategories: c,
          formatter: x
        }
      ),
      /* @__PURE__ */ n(
        Nr,
        {
          option: O,
          onEvents: $,
          lazyUpdate: !0,
          style: { height: a, width: l }
        }
      )
    ] }),
    b.length > 0 && /* @__PURE__ */ n(
      An,
      {
        series: b,
        selectedCategories: c,
        onCategoryClick: y && P
      }
    )
  ] });
}
function Hr(e, t, i) {
  var s;
  const r = Array.isArray(e) ? e[0] : e;
  if (!r)
    return null;
  const o = ge(t(r.value)), a = i(r.percent) || `${r.percent}%`, d = `display:inline-block;border-radius:4px;width:8px;height:8px;background-color:${((s = r.data) == null ? void 0 : s.color) || r.textStyle.color}`;
  return `
    <div style="white-space:normal;"><p style="max-width:${ht};font-size:11px;font-weight:500;line-height:1.454;text-transform:uppercase;margin:0 0 4px 0;">${r.name}</p>
    <p style="display:flex;align-items:center;font-size: 11px;font-weight:500;line-height:1.454;margin:0;"><span style="${d}"></span> <span style="margin:0 4px;font-weight:400;">${o}</span> (${a})</p></div>
  `.trim();
}
const zr = m(ae)(({ theme: e }) => ({
  position: "relative",
  alignItems: "center",
  height: e.spacing(4)
})), jr = m(ae)(({ theme: e }) => ({
  position: "absolute",
  zIndex: 1,
  padding: e.spacing(0, 3)
}));
function Yr() {
  return /* @__PURE__ */ v(ae, { container: !0, children: [
    /* @__PURE__ */ v(zr, { container: !0, item: !0, children: [
      /* @__PURE__ */ v(jr, { container: !0, item: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ n(Rt, { variant: "circular", width: 12, height: 12 }),
        /* @__PURE__ */ n(Rt, { variant: "circular", width: 12, height: 12 })
      ] }),
      /* @__PURE__ */ n(z, { height: 2, width: "100%" })
    ] }),
    /* @__PURE__ */ v(ae, { container: !0, item: !0, justifyContent: "space-between", children: [
      /* @__PURE__ */ n(z, { width: 56, height: 32 }),
      /* @__PURE__ */ n(z, { width: 56, height: 32 })
    ] })
  ] });
}
const Vr = m(S)(() => ({
  position: "relative"
})), Gr = m(S)(({ theme: { spacing: e } }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  height: e(1.5)
})), Ur = m(ye)(() => ({
  cursor: "pointer"
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
})), jt = m(ot)(({ theme: { spacing: e } }) => ({
  maxWidth: e(9),
  margin: 0,
  "& fieldset": {
    borderWidth: 1
  },
  "& input": {
    "&[type=number]": {
      appearance: "textfield"
    },
    "&::-webkit-outer-spin-button": {
      appearance: "none",
      margin: 0
    },
    "&::-webkit-inner-spin-button": {
      appearance: "none",
      margin: 0
    }
  }
})), Xr = m(xt)(({ theme: { palette: e } }) => ({
  "& .MuiSlider-rail": {
    color: e.text.hint
  }
})), qr = m(xt)(({ theme: { palette: e, spacing: t } }) => ({
  pointerEvents: "none",
  position: "absolute",
  zIndex: 1,
  left: 0,
  right: 0,
  "& .MuiSlider-rail": {
    display: "none"
  },
  "& .MuiSlider-thumb": {
    display: "none"
  },
  "& .MuiSlider-track": {
    color: e.primary.main,
    opacity: 0.38
  },
  "& .MuiSlider-mark, & .MuiSlider-markActive": {
    backgroundColor: e.primary.main,
    opacity: 0.38,
    height: t(1),
    width: t(0.25),
    top: "50%",
    transform: "translateY(-50%)"
  }
}));
function ss({
  data: e,
  min: t,
  max: i,
  limits: r,
  onSelectedRangeChange: o,
  isLoading: a
}) {
  const [l, d] = _([t, i]), [s, u] = _([
    t,
    i
  ]), p = se(), c = ce(p), { showSkeleton: y } = ke(!!a), g = F(() => {
    if (!r || r.length !== 2)
      return;
    if (r[0] === r[1])
      return [{ value: r[0] }];
    const x = [
      { value: Math.max(r[0], t) },
      { value: Math.min(r[1], i) }
    ];
    if (!(x[0].value > x[1].value))
      return x;
  }, [r, i, t]), f = F(
    () => o ? ri(o, 250) : null,
    [o]
  ), w = (x) => {
    u([...x]), d([...x]), f && f([...x]);
  };
  function h(x, A) {
    const C = x.target.value === "" ? "" : Number(x.target.value);
    A === 0 && u([C, s[1]]), A === 1 && u([s[0], C]);
  }
  const b = t !== s[0] || i !== s[1];
  U(() => {
    e && (u([...e]), d([...e]));
  }, [e]);
  function k(x) {
    let A = s[x];
    A === "" && (A = l[x]), A > i && (A = i), A < t && (A = t);
    const C = x === 0 ? [A, s[1]] : [s[0], A];
    w(C.sort((O, L) => O - L));
  }
  const M = () => {
    w([t, i]);
  };
  function T(x) {
    x.key === "Enter" && M();
  }
  return y ? /* @__PURE__ */ n(Yr, {}) : /* @__PURE__ */ v(Vr, { children: [
    /* @__PURE__ */ n(Gr, { children: b && /* @__PURE__ */ n(H, { variant: "caption", color: "primary", children: /* @__PURE__ */ n(
      Ur,
      {
        onClick: M,
        onKeyDown: T,
        tabIndex: 0,
        component: "button",
        underline: "hover",
        children: c.formatMessage({ id: "c4r.widgets.range.clear" })
      }
    ) }) }),
    /* @__PURE__ */ v(S, { children: [
      /* @__PURE__ */ n(
        Xr,
        {
          getAriaLabel: (x) => x === 0 ? c.formatMessage({ id: "c4r.widgets.range.minValue" }) : c.formatMessage({ id: "c4r.widgets.range.maxValue" }),
          value: l,
          min: t,
          max: i,
          onChange: (x, A) => w(A)
        }
      ),
      r && r.length === 2 && /* @__PURE__ */ n(
        qr,
        {
          getAriaLabel: (x) => x === 0 ? c.formatMessage({ id: "c4r.widgets.range.minLimit" }) : c.formatMessage({ id: "c4r.widgets.range.maxLimit" }),
          value: r,
          min: t,
          max: i,
          marks: g
        }
      )
    ] }),
    /* @__PURE__ */ v(S, { display: "flex", justifyContent: "space-between", mb: 1, children: [
      /* @__PURE__ */ n(
        jt,
        {
          value: s[0],
          size: "small",
          onChange: (x) => h(x, 0),
          onBlur: () => k(0),
          inputProps: {
            min: t,
            max: i,
            type: "number",
            "aria-label": c.formatMessage({
              id: "c4r.widgets.range.minValue"
            })
          }
        }
      ),
      /* @__PURE__ */ n(
        jt,
        {
          value: s[1],
          size: "small",
          onChange: (x) => h(x, 1),
          onBlur: () => k(1),
          inputProps: {
            min: t,
            max: i,
            type: "number",
            "aria-label": c.formatMessage({
              id: "c4r.widgets.range.maxValue"
            })
          }
        }
      )
    ] })
  ] });
}
const Kr = m(bn)(({ theme: e }) => ({
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: e.spacing(4),
  containerType: "inline-size",
  [`@container (max-width: ${Mt.XS}px)`]: {
    " > div": {
      maxWidth: "75%"
    }
  }
})), Zr = m(S)(() => ({
  position: "relative",
  display: "flex",
  justifyContent: "space-between",
  width: "80%",
  maxWidth: "50%"
}));
function Jr({ height: e }) {
  function t() {
    return Math.floor(Math.random() * 5);
  }
  return /* @__PURE__ */ v(S, { height: e ?? at, children: [
    /* @__PURE__ */ n(S, { mb: 4, children: /* @__PURE__ */ n(z, { width: 48, height: 8 }) }),
    /* @__PURE__ */ n(Kr, { height: "80%", children: [...Array(3)].map((i, r) => (
      // Every row is placed with an incremental margin left to reinforce the effect of a scatter plot
      /* @__PURE__ */ n(Zr, { ml: r * 3, children: [...Array(4)].map((o, a) => (
        // Random margins are used to create the effect of a scatter plot
        /* @__PURE__ */ n(S, { mt: t(), ml: t(), children: /* @__PURE__ */ n(z, { variant: "circular", width: 12, height: 12 }) }, a)
      )) }, r)
    )) })
  ] });
}
function Qr(e, t) {
  var s;
  const i = Array.isArray(e.tooltip) ? e.tooltip[0] : e.tooltip, r = Array.isArray(t.tooltip) ? t.tooltip[0] : t.tooltip, o = i == null ? void 0 : i.formatter, a = r == null ? void 0 : r.formatter, l = (s = e.series[0]) == null ? void 0 : s.data, d = t.series[0].data;
  return o !== a ? !1 : l && d && l.length === d.length ? !d.some(({ value: u }, p) => {
    var c;
    return u !== ((c = l[p]) == null ? void 0 : c.value);
  }) : !1;
}
function eo({
  tooltipFormatter: e,
  xAxisFormatter: t = tt,
  yAxisFormatter: i = tt
}, r) {
  return {
    grid: {
      top: 10,
      left: 5,
      bottom: 10,
      right: 15,
      containLabel: !0
    },
    tooltip: {
      padding: [B * 0.5, B],
      textStyle: {
        ...r.typography.caption,
        fontSize: 11,
        color: r.palette.common.white
      },
      backgroundColor: r.palette.black[90],
      ...e ? { formatter: e } : {}
    },
    color: [r.palette.secondary.main],
    xAxis: {
      axisLabel: {
        ...r.typography.overlineDelicate,
        padding: [B * 0.5, 0, 0, 0],
        formatter: (o) => ge(t(o))
      }
    },
    yAxis: {
      axisLabel: {
        ...r.typography.overlineDelicate,
        formatter: (o) => ge(i(o))
      }
    }
  };
}
function to({
  name: e,
  data: t,
  animation: i
}) {
  return [
    {
      type: "scatter",
      name: e,
      data: t,
      animation: i
    }
  ];
}
const no = Qn.memo(
  We,
  (e, t) => Qr(
    e.option,
    t.option
  )
), Yt = 225, io = [], tt = (e) => e;
function cs({
  name: e = null,
  data: t = io,
  animation: i = !0,
  xAxisFormatter: r = tt,
  yAxisFormatter: o = tt,
  tooltipFormatter: a = ro,
  isLoading: l
}) {
  const d = le(), s = re(), [u, p] = _({
    series: []
  }), { showSkeleton: c } = ke(!!l);
  return U(() => {
    const y = eo(
      { xAxisFormatter: r, yAxisFormatter: o, tooltipFormatter: a },
      d
    ), g = to({
      name: e,
      data: t || [],
      animation: i
    });
    p({
      ...y,
      series: g
    });
  }, [
    t,
    e,
    i,
    d,
    r,
    o,
    a
  ]), c ? /* @__PURE__ */ n(Jr, { height: Yt }) : /* @__PURE__ */ n(
    no,
    {
      ref: s,
      option: u,
      lazyUpdate: !0,
      style: { height: Yt }
    }
  );
}
function ro(e) {
  const t = Array.isArray(e) ? e[0] : e, i = (t == null ? void 0 : t.value) || [];
  return `[${i[0]}, ${i[1]})`;
}
function Ue({
  width: e,
  rows: t = 4,
  index: i = 0
}) {
  function r(o) {
    const a = [72, 48, 96, 32, 64], l = o % a.length;
    return a[l];
  }
  return [...Array(t)].map((o, a) => /* @__PURE__ */ n(bt, { children: /* @__PURE__ */ n(z, { width: e ?? r(i), height: 8 }) }, a));
}
const oo = m(S)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: e.spacing(2),
  margin: 0,
  padding: e.spacing(2, 1)
})), ao = m(un)(() => ({
  overflow: "hidden"
}));
function lo({
  style: e,
  dense: t,
  pagination: i,
  rowsPerPage: r
}) {
  return /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(ao, { style: e, children: /* @__PURE__ */ v(sn, { "aria-label": "Skeleton table", size: t ? "small" : "medium", children: [
      /* @__PURE__ */ n(cn, { children: /* @__PURE__ */ v(Je, { children: [
        /* @__PURE__ */ n(Ue, { rows: 1, width: 8 }),
        /* @__PURE__ */ n(Ue, { width: 56 })
      ] }) }),
      /* @__PURE__ */ n(dn, { children: [...Array(Math.min(10, r ?? 10))].map(
        (o, a) => /* @__PURE__ */ v(Je, { children: [
          /* @__PURE__ */ n(Ue, { rows: 1, width: 8 }),
          /* @__PURE__ */ n(Ue, { index: a })
        ] }, a)
      ) })
    ] }) }),
    i && /* @__PURE__ */ v(oo, { children: [
      /* @__PURE__ */ n(z, { width: 56, height: 8 }),
      /* @__PURE__ */ n(S, { mr: 1, children: /* @__PURE__ */ n(z, { width: 52, height: 16 }) }),
      /* @__PURE__ */ n(z, { width: 60, height: 8 }),
      /* @__PURE__ */ n(z, { width: 16, height: 16 }),
      /* @__PURE__ */ n(z, { width: 16, height: 16 })
    ] })
  ] });
}
const so = m(oi)(({ theme: e }) => ({
  ...e.typography.caption,
  color: e.palette.text.secondary,
  whiteSpace: "nowrap"
})), co = m(Je)(({ theme: e }) => ({
  maxHeight: e.spacing(6.5),
  transition: "background-color 0.25s ease",
  "&.MuiTableRow-hover:hover": {
    cursor: "pointer",
    backgroundColor: e.palette.background.default
  }
})), uo = m(bt)(() => ({
  overflow: "hidden",
  "& p": {
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
})), po = m(ai)(({ theme: e }) => ({
  height: e.spacing(6),
  overflowX: "auto",
  overflowY: "hidden"
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
})), go = 10, ho = [5, 10, 25], Be = () => {
};
function ds({
  columns: e,
  rows: t,
  sorting: i = !1,
  sortBy: r,
  sortDirection: o = "asc",
  onSetSortBy: a = Be,
  onSetSortDirection: l = Be,
  pagination: d = !1,
  totalCount: s,
  page: u,
  onSetPage: p = Be,
  rowsPerPage: c = go,
  rowsPerPageOptions: y = ho,
  onSetRowsPerPage: g = Be,
  onRowClick: f = Be,
  onRowMouseEnter: w,
  onRowMouseLeave: h,
  height: b,
  dense: k = !1,
  isLoading: M,
  lastPageTooltip: T
}) {
  var G;
  const x = re(null), A = se(), C = ce(A), { showSkeleton: O } = ke(!!M);
  function L({
    from: D,
    to: N,
    count: I
  }) {
    return C.formatMessage(
      { id: "c4r.widgets.table.of" },
      { from: D, to: N, count: I }
    );
  }
  function P(D) {
    l(r === D && o === "asc" ? "desc" : "asc"), a(D);
  }
  function $(D, N) {
    p(N);
  }
  function W(D) {
    g(parseInt(D.target.value, 10)), p(0);
  }
  const J = { height: void 0 };
  if (b) {
    const D = Math.max(
      ((G = x == null ? void 0 : x.current) == null ? void 0 : G.clientHeight) ?? 0,
      d ? B * 6 : 0
    );
    J.height = `calc(${b} - ${D}px)`;
  }
  return O ? /* @__PURE__ */ n(
    lo,
    {
      rowsPerPage: c,
      style: J,
      dense: k,
      pagination: d
    }
  ) : /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(un, { style: J, children: /* @__PURE__ */ v(sn, { stickyHeader: !0, size: k ? "small" : "medium", children: [
      /* @__PURE__ */ n(
        fo,
        {
          columns: e,
          sorting: i,
          sortBy: r,
          sortDirection: o,
          onSort: P
        }
      ),
      /* @__PURE__ */ n(
        mo,
        {
          columns: e,
          rows: t,
          onRowMouseEnter: w,
          onRowMouseLeave: h,
          onRowClick: f
        }
      )
    ] }) }),
    d && /* @__PURE__ */ n(
      po,
      {
        ref: x,
        rowsPerPageOptions: y,
        labelRowsPerPage: C.formatMessage({
          id: "c4r.widgets.table.rowsPerPage"
        }),
        labelDisplayedRows: L,
        component: "div",
        count: s,
        rowsPerPage: c,
        page: u,
        onPageChange: $,
        onRowsPerPageChange: W,
        ActionsComponent: () => /* @__PURE__ */ n(
          vi,
          {
            count: s,
            rowsPerPage: c,
            page: u,
            onPageChange: $,
            lastPageTooltip: T
          }
        )
      }
    )
  ] });
}
function fo({
  columns: e,
  sorting: t,
  sortBy: i,
  sortDirection: r,
  onSort: o
}) {
  return /* @__PURE__ */ n(cn, { children: /* @__PURE__ */ n(Je, { children: e.map(({ field: a, headerName: l, align: d }) => /* @__PURE__ */ n(bt, { align: d ?? "left", children: t ? /* @__PURE__ */ n(
    so,
    {
      active: i === a,
      direction: i === a ? r : "asc",
      onClick: () => o(a),
      children: l ?? a
    }
  ) : l ?? a }, a)) }) });
}
function mo({
  columns: e,
  rows: t,
  onRowMouseEnter: i,
  onRowMouseLeave: r,
  onRowClick: o
}) {
  return /* @__PURE__ */ n(dn, { children: t.map((a, l) => {
    const d = String(a.cartodb_id || a.id || l);
    return /* @__PURE__ */ n(
      co,
      {
        hover: !!o,
        onMouseEnter: () => i == null ? void 0 : i(a),
        onMouseLeave: () => r == null ? void 0 : r(a),
        onClick: () => o && o(a),
        children: e.map(
          ({ field: s, headerName: u, align: p, component: c, formatter: y }) => {
            var f;
            let g = (f = Object.entries(a).find(([w]) => w.toUpperCase() === s.toUpperCase())) == null ? void 0 : f[1];
            return y ? g = y(g) : typeof g == "bigint" ? g = g.toString() : Array.isArray(g) ? g = `[${g.map((w) => typeof w == "string" ? `"${w}"` : String(w)).join(", ")}]` : typeof g == "object" && g !== null && (g = JSON.stringify(g)), (u ?? s) && /* @__PURE__ */ n(
              uo,
              {
                scope: "row",
                align: p ?? "left",
                children: c ? c(g) : g
              },
              `${d}_${s}`
            );
          }
        )
      },
      d
    );
  }) });
}
function En(e, t, i, r, o) {
  const a = Array.isArray(e) ? e : [e], [l] = a[0].data, d = new Date(l);
  return `<div style='minWidth: 160px;'>
    <p style='font-weight: 600; line-height: 1; margin: 4px 0;'>${Dn({ date: d, stepMultiplier: r, stepSize: t })}</p>
    ${a.reduce((u, p) => {
    if (p.value !== void 0 && p.value !== null) {
      const c = `<div style='display: flex; flex-direction: row; align-items: center; justify-content: spread; height: 20px; gap: 8px;'>
            <div style='display: flex; flex-direction: row; align-items: center; margin: 4px 0;'>
              <div style='width: 8px; height: 8px; margin-right: 4px; border-radius: 50%; border: 2px solid ${String(
        p.color
      )}'></div>
            </div>
            <p style='line-height: 1; flex: 1; margin-left: 0.5em; min-width: 20px; max-width: 200px; overflow: hidden; text-overflow: ellipsis; align-self: left;'>
            ${o && p.seriesName ? `${p.seriesName}</p>` : ""}
            </p>
            <p style='line-height: 1; justify-self: flex-end;'>${i(
        p.data[1]
      )}</p>
          </div>`;
      u.push(c);
    }
    return u;
  }, []).join("")}
    </div>`;
}
var It = /* @__PURE__ */ ((e) => (e.LINE = "line", e.BAR = "bar", e))(It || {});
function Vt(e) {
  if (typeof e == "object" && typeof (e == null ? void 0 : e.getTime) == "function")
    return e.getTime();
  const t = new Date(e).getTime();
  if (isFinite(t))
    return t;
}
function Ln(e) {
  return typeof e == "object" && typeof (e == null ? void 0 : e.getTime) == "function" ? e : new Date(e);
}
function nt(e, t) {
  var i, r;
  for (let o = 0; o < t.length; o++) {
    const a = t[o].name, l = o < t.length ? (i = t[o + 1]) == null ? void 0 : i.name : a, d = o > 0 ? (r = t[o - 1]) == null ? void 0 : r.name : a, s = Math.abs(a - l), u = Math.abs(a - d), p = a - u * 0.5, c = a + s * 0.5;
    if (isFinite(p) && isFinite(c)) {
      if (e >= p && e <= c)
        return o;
    } else if (isFinite(p)) {
      if (e >= p)
        return o;
    } else if (isFinite(c) && e <= c)
      return o;
  }
}
function yo(e) {
  let t, i = 0;
  for (const { name: r } of e)
    r !== t && (t = r, i++);
  return i;
}
function wo(e) {
  const t = new Date(e), i = t.getDay(), r = t.getDate() - i + (i ? 1 : -6);
  return t.setDate(r), t.setHours(0, 0, 0, 0), t.getTime();
}
var Se = /* @__PURE__ */ ((e) => (e.YEARS = "year", e.MONTHS = "month", e.WEEKS = "week", e.DAYS = "day", e.HOURS = "hour", e.MINUTES = "minute", e.SECONDS = "second", e))(Se || {});
const Tt = {
  year: Ee,
  month: Ee,
  week: Ee,
  day: Ee,
  hour: ko,
  minute: Gt,
  second: Gt
}, vo = {
  year: Lo,
  month: Eo,
  week: Ao,
  day: Co,
  hour: To,
  minute: Io,
  second: Mo
};
function xo({
  date: e,
  stepSize: t
}) {
  const i = Tt[t];
  if (!i) throw new Error("formatTime: invalid stepSize");
  return i(e);
}
function it({
  start: e,
  end: t,
  stepSize: i
}) {
  if (e > t)
    return it({ start: t, end: e, stepSize: i });
  const r = Tt[i];
  if (!r)
    throw new Error("formatTimeRange: missing formatter or invalid stepSize");
  const o = r(e), a = r(t);
  return `${o} - ${a}`;
}
function Dn({
  date: e,
  stepSize: t,
  stepMultiplier: i
}) {
  if (!Tt[t])
    throw new Error("formatBucketRange: missing formatter or invalid stepSize");
  const { start: o, end: a } = So({ date: e, stepSize: t, stepMultiplier: i });
  if (i === 1) {
    if (t === "day")
      return xo({ date: o, stepSize: t });
    if (t === "second")
      return `${Ee(o)} ${ft(
        o
      )} - ${ft(a)}`;
  }
  return it({ start: o, end: a, stepSize: t });
}
const Ct = (e) => 1e3 * e, At = (e) => Ct(60 * e), bo = (e) => At(60 * e);
function Ee(e) {
  return e.toLocaleDateString();
}
function ko(e) {
  return Ee(e) + " " + e.toLocaleTimeString(void 0, {
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  });
}
function ft(e) {
  return e.toLocaleTimeString(void 0, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: !0,
    second: "2-digit"
  });
}
function Gt(e) {
  return Ee(e) + " " + ft(e);
}
function So({
  date: e,
  stepSize: t,
  stepMultiplier: i = 1
}) {
  const r = vo[t];
  if (!r)
    throw new Error("getBucketInterval: invalid bucket size");
  return r({ date: e, stepMultiplier: i });
}
function Mo({
  date: e,
  stepMultiplier: t = 1
}) {
  const i = new Date(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    0
  ), r = new Date(i.getTime() + Ct(t - 1) + 999);
  return { start: i, end: r };
}
function Io({
  date: e,
  stepMultiplier: t = 1
}) {
  const i = new Date(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    0,
    0
  ), r = new Date(
    i.getTime() + At(t - 1) + Ct(59)
  );
  return { start: i, end: r };
}
function To({
  date: e,
  stepMultiplier: t = 1
}) {
  const i = new Date(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    0,
    0,
    0
  ), r = new Date(
    i.getTime() + bo(t - 1) + At(59)
  );
  return { start: i, end: r };
}
function Co({
  date: e,
  stepMultiplier: t = 1
}) {
  const i = new Date(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    0,
    0,
    0,
    0
  ), r = new Date(
    e.getFullYear(),
    e.getMonth(),
    e.getDate() + t - 1
  );
  return { start: i, end: r };
}
function Ao({
  date: e,
  stepMultiplier: t = 1
}) {
  const i = new Date(wo(e)), r = new Date(
    i.getFullYear(),
    i.getMonth(),
    i.getDate() + 6 + 7 * (t - 1)
  );
  return { start: i, end: r };
}
function Eo({
  date: e,
  stepMultiplier: t = 1
}) {
  const i = new Date(e.getFullYear(), e.getMonth(), 1), r = new Date(e.getFullYear(), e.getMonth() + t, 0);
  return { start: i, end: r };
}
function Lo({
  date: e,
  stepMultiplier: t = 1
}) {
  const i = new Date(e.getFullYear(), 0, 1), r = new Date(e.getFullYear() + (t - 1), 11, 31);
  return { start: i, end: r };
}
const me = () => {
}, $n = ti({
  isPlaying: !1,
  setIsPlaying: me,
  isPaused: !1,
  setIsPaused: me,
  timeWindow: [],
  setTimeWindow: me,
  onTimeWindowUpdate: me,
  togglePlay: me,
  stop: me,
  intl: {}
});
function Et() {
  return ni($n);
}
function Do({
  children: e,
  isPlaying: t,
  isPaused: i,
  onPlay: r = me,
  onPause: o = me,
  onStop: a = me,
  timeWindow: l,
  onTimeWindowUpdate: d = me,
  intl: s
}) {
  const [u, p] = _(t), [c, y] = _(i), [g, f] = _([]), w = ce(s);
  U(() => {
    const M = g.sort((T, x) => T < x ? -1 : 1).map(Ln);
    d == null || d(M);
  }, [g, d]);
  const h = oe(() => {
    u && (o && o(), y(!0)), u || (r && r(), y(!1)), p((M) => !M);
  }, [u, o, r]), b = oe(() => {
    p(!1), y(!1), f([]);
  }, []), k = oe(() => {
    b(), setTimeout(a);
  }, [a, b]);
  return U(() => {
    t !== u && p(t);
  }, [t]), U(() => {
    i !== c && y(i);
  }, [i]), U(() => {
    if (!l) return;
    const M = l.map(Vt), T = g.map(Vt);
    (M[0] !== T[0] || M[1] !== T[1]) && f(M);
  }, l), /* @__PURE__ */ n(
    $n.Provider,
    {
      value: {
        isPlaying: !!u,
        setIsPlaying: p,
        isPaused: !!c,
        setIsPaused: y,
        timeWindow: g,
        setTimeWindow: f,
        onTimeWindowUpdate: d,
        togglePlay: h,
        stop: k,
        intl: w
      },
      children: e
    }
  );
}
const Ut = {};
let Xe = null;
const _e = { seriesId: "0" };
function $o({
  echartsInstance: e,
  data: t,
  canSelectLines: i,
  filterable: r
}) {
  const o = le(), { isPlaying: a, isPaused: l, setIsPaused: d, timeWindow: s, setTimeWindow: u, stop: p } = Et(), [c, y] = _(!1), [g, f] = _(!1), [w, h] = _(!1), [b, k] = _(0), M = F(() => e == null ? void 0 : e.getZr(), [e]), T = oe(
    (O) => M == null ? void 0 : M.setCursorStyle(O),
    [M]
  ), x = oe(
    (O) => {
      if (e) {
        const [L] = e.convertFromPixel(_e, [
          O.offsetX,
          O.offsetY
        ]), P = nt(L, t);
        u(P !== void 0 ? [t[P].name] : []);
      }
    },
    [t, e, u]
  );
  U(() => {
    function O(L) {
      r && (i && L.target || (s.length || (x(L), !l && !a && d(!0)), s.length === 2 && (u([]), p())));
    }
    return qe(M, "click", O);
  }, [
    M,
    l,
    a,
    d,
    u,
    p,
    s.length,
    x,
    i,
    r
  ]), U(() => {
    function O(L) {
      var P;
      if (r) {
        if (((P = L.target) == null ? void 0 : P.type) === "ec-line") {
          y(!0), T("grabbing");
          return;
        }
        if (s.length === 2) {
          const [$] = e.convertFromPixel(_e, [
            L.offsetX,
            L.offsetY
          ]);
          if ($ >= s[0] && $ <= s[1]) {
            h(!0);
            const W = $ - s[0];
            k(W);
            return;
          }
        }
        if (e) {
          f(!0);
          const [$] = e.convertFromPixel(_e, [
            L.offsetX,
            L.offsetY
          ]);
          Xe = $;
          return;
        }
      }
    }
    return qe(M, "mousedown", O);
  }, [M, e, s, T, r]), U(() => {
    function O(L) {
      var P;
      if (((P = L == null ? void 0 : L.target) == null ? void 0 : P.type) === "polygon" && T("move"), c && e && (x(L), T("grabbing")), g && e) {
        const [$] = e.convertFromPixel(_e, [
          L.offsetX,
          L.offsetY
        ]);
        u(Xe === $ ? [] : [Xe, $]);
      }
    }
    return qe(M, "mousemove", O);
  }, [
    M,
    e,
    g,
    c,
    u,
    T,
    x
  ]), U(() => {
    function O(L) {
      if (c && (y(!1), T("default")), g && (f(!1), Xe = null, s.length === 1 && u([])), w && e) {
        const [P] = e.convertFromPixel(_e, [
          L.offsetX,
          L.offsetY
        ]), $ = P - s[0];
        if (b) {
          const W = $ - b;
          u([s[0] + W, s[1] + W]);
        }
        h(!1);
      }
    }
    return qe(M, "mouseup", O);
  }, [
    M,
    e,
    w,
    g,
    c,
    b,
    u,
    s,
    T
  ]), U(() => {
    !r && s.length && u([]);
  }, [r, u, s.length]);
  const A = F(() => {
    var $;
    if (s.length !== 1)
      return;
    const O = s[0], L = nt(O, t);
    if (L === void 0)
      return;
    const P = ($ = t[L]) == null ? void 0 : $.name;
    return (
      // Cannot have markLine and markArea at the same time
      P !== void 0 && {
        symbol: ["none", "none"],
        animationDuration: 100,
        animationDurationUpdate: 150,
        animationEasingUpdate: "linear",
        data: l || a ? [
          {
            label: {
              show: !1
            },
            emphasis: {
              label: {
                show: !1
              }
            },
            xAxis: P,
            lineStyle: {
              type: "solid",
              color: o.palette.primary.main,
              width: 1.5,
              shadowColor: o.palette.primary.light,
              shadowBlur: 3
            }
          }
        ] : []
      }
    );
  }, [t, l, a, o, s]), C = F(
    () => s.length === 2 && {
      data: [[{ coord: [s[0]] }, { coord: [s[1]] }]],
      itemStyle: {
        color: o.palette.primary.main,
        opacity: 0.2
      }
    },
    [o, s]
  );
  return { timelineOptions: A, timeWindowOptions: C };
}
function qe(e, t, i) {
  if (e != null && e.handler)
    return Ut[t] = i, e.on(t, i), () => {
      Ut[t] && (e != null && e.handler) && e.off(t, i);
    };
}
const Pn = B * 22, On = "100%", Po = 5, Oo = 3, Wo = B * 20;
function Ro({
  chartType: e,
  formatter: t,
  timeAxisSplitNumber: i,
  tooltip: r,
  tooltipFormatter: o,
  data: a,
  series: l,
  categories: d,
  height: s,
  fitHeight: u,
  animation: p,
  filterable: c,
  selectedCategories: y,
  onCategoryClick: g,
  yAxisType: f
}) {
  const w = le(), [h, b] = _(), k = (D) => b(D), [M, T] = _(), x = F(
    () => l.reduce(
      (D, { data: N }) => N.reduce(
        (I, R) => R[1] > I ? R[1] : I,
        D
      ),
      Number.MIN_VALUE
    ),
    [l]
  ), A = F(
    () => ({
      show: r,
      trigger: "axis",
      appendToBody: !0,
      padding: [B * 0.5, B],
      textStyle: {
        ...w.typography.caption,
        fontSize: 11,
        color: w.palette.common.white
      },
      borderWidth: 0,
      backgroundColor: w.palette.black[90],
      position: (D, N, I, R, X) => {
        const j = { top: 0 };
        return X.contentSize[0] < X.viewSize[0] - D[0] ? j.left = D[0] + B * 1.5 : j.right = X.viewSize[0] - D[0] + B * 1.5, j;
      },
      ...o ? { formatter: o } : {}
    }),
    [w, r, o]
  ), C = F(() => {
    const D = {
      margin: 0,
      verticalAlign: "bottom",
      padding: [0, 0, B * 1.25, 0],
      inside: !0,
      color: (R) => {
        let X = "transparent";
        return R >= x && (X = w.palette.black[60]), X;
      }
    }, N = {
      margin: 0,
      verticalAlign: "middle",
      padding: [0, B * 0.75, 0, 0],
      color: w.palette.black[60]
    }, I = f === "dense" ? D : N;
    return {
      axisPointer: {
        lineStyle: {
          color: w.palette.black[40]
        }
      },
      xAxis: {
        type: "time",
        axisLine: {
          show: !0,
          lineStyle: {
            color: w.palette.grey[900],
            opacity: 0.2
          }
        },
        axisLabel: {
          fontWeight: w.typography.fontWeightRegular,
          fontSize: w.typography.caption.fontSize,
          fontFamily: w.typography.caption.fontFamily,
          // echarts doesn't intepret lineHeight properly, so hack it around
          lineHeight: w.typography.caption.lineHeight * 8,
          letterSpacing: w.typography.caption.letterSpacing,
          // https://echarts.apache.org/en/option.html#xAxis.axisLabel.formatter
          formatter: {
            year: "{yearStyle|{yyyy}}"
          },
          rich: {
            yearStyle: {
              fontWeight: w.typography.fontWeightMedium,
              fontSize: w.typography.caption.fontSize,
              fontFamily: w.typography.caption.fontFamily,
              letterSpacing: w.typography.caption.letterSpacing,
              lineHeight: w.typography.caption.lineHeight * 8
            }
          }
        },
        axisTick: {
          show: !1
        },
        splitNumber: i ?? (M !== void 0 ? Math.min(
          Oo,
          Math.ceil(M / Wo)
        ) : Po)
      },
      yAxis: {
        type: "value",
        axisLabel: {
          show: !0,
          showMaxLabel: !0,
          showMinLabel: !1,
          ...I,
          ...t ? { formatter: (R) => t(R) } : {},
          fontWeight: w.typography.fontWeightRegular,
          fontSize: w.typography.overlineDelicate.fontSize,
          fontFamily: w.typography.overlineDelicate.fontFamily,
          // echarts doesn't intepret lineHeight properly, so hack it around
          lineHeight: w.typography.overlineDelicate.lineHeight * 8,
          letterSpacing: w.typography.overlineDelicate.letterSpacing
        },
        axisLine: {
          show: !1
        },
        axisTick: {
          show: !1
        },
        splitLine: {
          show: !0,
          onZero: !1,
          lineStyle: {
            color: w.palette.black[4]
          }
        },
        max: x
      }
    };
  }, [w, x, t, M, i, f]), { timelineOptions: O, timeWindowOptions: L } = $o({
    echartsInstance: h,
    data: a,
    canSelectLines: !!g,
    filterable: c
  }), P = F(
    () => l.map(({ data: D, color: N, name: I }, R) => {
      const X = y && y.length > 0, j = X && y.includes(I), K = !X || j ? N : w.palette.action.disabledBackground;
      return {
        id: String(R),
        name: I,
        markLine: R === 0 ? O : void 0,
        markArea: R === 0 ? L : void 0,
        animation: p,
        data: D,
        type: e,
        smooth: !0,
        color: K,
        z: X && j ? 10 : 0,
        lineStyle: {
          width: 2
        },
        showSymbol: !1,
        emphasis: {
          scale: 2,
          lineStyle: {
            width: 2,
            color: K
          }
        }
      };
    }),
    [
      l,
      O,
      L,
      p,
      e,
      y,
      w
    ]
  ), $ = F(
    () => ({
      grid: {
        left: B * (f === "dense" ? 2 : 3.5),
        top: B * 4,
        right: B * 2,
        bottom: B * 3
      },
      color: [w.palette.secondary.main],
      tooltip: A,
      ...C,
      series: P
    }),
    [
      C,
      P,
      f,
      w.palette.secondary.main,
      A
    ]
  ), J = { click: oe(
    (D) => {
      if (d && g && D.componentType === "series") {
        const N = d[D.seriesIndex];
        g(N);
      }
    },
    [d, g]
  ) };
  U(() => {
    var I;
    if (typeof ResizeObserver > "u" || !h)
      return;
    const D = (I = h == null ? void 0 : h.getDom()) == null ? void 0 : I.parentElement;
    if (!D)
      return;
    const N = new ResizeObserver(() => {
      T(D.clientWidth), h.resize();
    });
    return N.observe(D), () => {
      N.disconnect();
    };
  }, [h]);
  const G = u ? On : s ?? Pn;
  return an(() => {
    var N;
    const D = (N = h == null ? void 0 : h.getDom()) == null ? void 0 : N.parentElement;
    D && T(D.clientWidth), h == null || h.resize();
  }, [G, u, h]), /* @__PURE__ */ n(
    We,
    {
      option: $,
      onEvents: J,
      onChartReady: k,
      style: { height: G }
    }
  );
}
const Fo = {
  [Se.YEARS]: 60 * 60 * 24 * 7,
  // Week
  [Se.MONTHS]: 60 * 60 * 24,
  // Day
  [Se.WEEKS]: 60 * 60 * 24,
  // Day
  [Se.DAYS]: 60 * 60 * 12,
  // Half day
  [Se.HOURS]: 60 * 60,
  // Hour
  [Se.MINUTES]: 60 * 15,
  // Quarter hour
  [Se.SECONDS]: 1
  // Second
}, No = [0.5, 1, 2, 3];
function Bo({
  data: e,
  stepSize: t
}) {
  const [i, r] = _(null), [o, a] = _(1), l = re({ animationFrameId: null, timeoutId: null }), {
    isPlaying: d,
    isPaused: s,
    timeWindow: u,
    setTimeWindow: p,
    stop: c,
    togglePlay: y,
    intl: g
  } = Et();
  Yo(
    () => (d || s) && c(),
    // Only executed when data changes
    [e]
  );
  const f = () => {
    const { animationFrameId: T, timeoutId: x } = l.current;
    T && window.cancelAnimationFrame(T), x && clearTimeout(x);
  }, w = oe(() => {
    f(), c();
  }, [c]), h = () => {
    f(), y();
  };
  U(() => {
    if (d && u.length === 2 && e.length) {
      const x = Fo[t] * 1e3;
      return Vo({
        data: e,
        timeWindow: u,
        msTimeWindowStep: x * o,
        drawFrame: (A) => {
          p(A);
        },
        onEnd: () => {
          setTimeout(w, 250);
        },
        animationRef: l
      }), () => f();
    }
  }, [e, d, t, p, w, o]), U(() => {
    if (d && u.length === 1 && e.length)
      return Uo({
        speed: o,
        timelinePosition: u[0],
        data: e,
        drawFrame: (T) => {
          p([T]);
        },
        onEnd: () => {
          setTimeout(w, 250);
        },
        animationRef: l
      }), () => f();
    d && u.length === 0 && p([e[0].name]);
  }, [e, d, o, u.length, w]);
  const b = (T) => {
    T != null && T.currentTarget && r(T.currentTarget);
  }, k = () => {
    r(null);
  }, M = (T) => {
    a(T), k();
  };
  return /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(
      fe,
      {
        size: "small",
        color: "default",
        onClick: b,
        "data-testid": "clock",
        children: /* @__PURE__ */ n(_o, {})
      }
    ),
    /* @__PURE__ */ v(
      kt,
      {
        anchorEl: i,
        keepMounted: !0,
        open: !!i,
        onClose: k,
        children: [
          /* @__PURE__ */ n(Pe, { disabled: !0, children: /* @__PURE__ */ n(H, { variant: "caption", color: "textSecondary", children: g.formatMessage({ id: "c4r.widgets.timeSeries.speed" }) }) }),
          No.map((T) => /* @__PURE__ */ v(
            Pe,
            {
              selected: T === o,
              onClick: () => M(T),
              children: [
                T,
                "x"
              ]
            },
            T
          ))
        ]
      }
    ),
    /* @__PURE__ */ n(S, { mt: 2, children: /* @__PURE__ */ n(
      fe,
      {
        size: "small",
        color: "primary",
        disabled: !(s || d),
        onClick: w,
        "data-testid": "stop",
        children: /* @__PURE__ */ n(zo, {})
      }
    ) }),
    /* @__PURE__ */ n(S, { mt: 0.75, children: /* @__PURE__ */ n(
      fe,
      {
        "data-testid": "play-pause",
        size: "small",
        color: "primary",
        onClick: h,
        children: d ? /* @__PURE__ */ n(jo, {}) : /* @__PURE__ */ n(Ho, {})
      }
    ) })
  ] });
}
function _o() {
  return /* @__PURE__ */ n(je, { viewBox: "0 0 20 20", children: /* @__PURE__ */ n(
    "path",
    {
      d: "M12.5 1.254h-5v1.667h5V1.254zM9.167 12.088h1.666v-5H9.167v5zm6.691-5.517 1.184-1.183a9.207 9.207 0 0 0-1.175-1.175l-1.184 1.183A7.468 7.468 0 0 0 10 3.746a7.5 7.5 0 0 0-7.5 7.5c0 4.141 3.35 7.5 7.5 7.5s7.5-3.358 7.5-7.5a7.504 7.504 0 0 0-1.642-4.675zM10 17.088a5.83 5.83 0 0 1-5.833-5.834A5.83 5.83 0 0 1 10 5.421a5.83 5.83 0 0 1 5.833 5.833A5.83 5.83 0 0 1 10 17.087z",
      id: "-↳Color",
      fill: "inherit"
    }
  ) });
}
function Ho() {
  return /* @__PURE__ */ n(je, { "data-testid": "play-icon", children: /* @__PURE__ */ n(
    "path",
    {
      d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
      id: "-↳Color",
      fill: "inherit"
    }
  ) });
}
function zo() {
  return /* @__PURE__ */ n(je, { children: /* @__PURE__ */ n(
    "path",
    {
      d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 2c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4 4v8H8V8h8zm-2 2h-4v4h4v-4z",
      id: "-↳Color",
      fill: "inherit"
    }
  ) });
}
function jo() {
  return /* @__PURE__ */ n(je, { "data-testid": "pause-icon", children: /* @__PURE__ */ n(
    "path",
    {
      d: "M9,16 L11,16 L11,8 L9,8 L9,16 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z M13,16 L15,16 L15,8 L13,8 L13,16 Z",
      id: "-↳Color",
      fill: "inherit"
    }
  ) });
}
function Yo(e, t = []) {
  const i = re(!1);
  U(() => {
    i.current ? e() : i.current = !0;
  }, t);
}
function Vo({
  msTimeWindowStep: e,
  timeWindow: t,
  data: i,
  drawFrame: r,
  onEnd: o,
  animationRef: a
}) {
  let l = t;
  const d = () => {
    a.current.animationFrameId = window.requestAnimationFrame(s);
  }, s = () => {
    l = [
      l[0] + e,
      l[1] + e
    ], l[1] > i[i.length - 1].name ? o() : (r(l), d());
  };
  d();
}
const Go = 2;
function Uo({
  speed: e,
  timelinePosition: t,
  data: i,
  drawFrame: r,
  onEnd: o,
  animationRef: a
}) {
  let l = nt(t, i) ?? 0, d = i[l].name;
  const s = yo(i), u = Math.max(
    Math.round(Math.sqrt(s) / 2),
    // FPS based on number of unique time points
    Go
    // Min FPS
  ) * e, p = () => {
    a.current.timeoutId = setTimeout(() => {
      a.current.animationFrameId = window.requestAnimationFrame(c);
    }, 1e3 / u);
  }, c = () => {
    for (; l < i.length; l++) {
      const y = i[l].name;
      if (y !== d) {
        d = y;
        break;
      }
    }
    l === i.length ? o() : (r(d), p());
  };
  p();
}
const Xo = m(S)(() => ({
  containerType: "inline-size",
  display: "flex",
  flexDirection: "column"
})), qo = m(S)(() => ({
  display: "flex",
  flexDirection: "column"
})), Wn = m(S)(() => ({
  display: "flex",
  flexDirection: "row"
})), Ko = m(Wn)(() => ({
  alignItems: "center",
  justifyContent: "space-between"
})), Zo = m(S)(({ theme: e }) => ({
  flexShrink: 0,
  marginLeft: 0,
  paddingLeft: e.spacing(1),
  [`@container (max-width: ${Mt.XS}px)`]: {
    paddingLeft: 0
  },
  paddingBottom: e.spacing(1.5),
  alignSelf: "flex-end"
})), Jo = m(S)(({ theme: e }) => ({
  alignSelf: "normal",
  minWidth: 0,
  paddingLeft: e.spacing(5),
  paddingBottom: e.spacing(1.5),
  [`@container (max-width: ${Mt.XS}px)`]: {
    paddingLeft: e.spacing(1)
  }
}));
function Rn({
  fitHeight: e,
  header: t,
  controls: i,
  chart: r,
  legend: o
}) {
  const a = o && /* @__PURE__ */ n(S, { flex: 0, mt: 2, children: o });
  return /* @__PURE__ */ v(
    Xo,
    {
      style: {
        flex: e ? "1" : void 0
      },
      children: [
        /* @__PURE__ */ n(Ko, { flex: 0, children: t }),
        i ? /* @__PURE__ */ v(qo, { flex: 1, children: [
          /* @__PURE__ */ v(Wn, { flex: 1, children: [
            /* @__PURE__ */ n(Zo, { flex: 0, children: i }),
            /* @__PURE__ */ n(Jo, { flex: 1, children: r })
          ] }),
          a
        ] }) : /* @__PURE__ */ v(ie, { children: [
          /* @__PURE__ */ n(S, { pb: 1.5, flex: 1, children: r }),
          a
        ] })
      ]
    }
  );
}
const Qo = (e) => /* @__PURE__ */ n(je, { width: "720", height: "124", viewBox: "0 0 720 124", ...e, children: /* @__PURE__ */ n(
  "path",
  {
    d: "M0.74707 123C11.8168 119.656 26.7934 118.37 53.4909 102.164C73.1959 90.2031 92.5604 81.3284 108.188 76.6983C122.841 72.357 136.188 74.3832 144.653 75.1549C150.496 75.6876 195.443 82.8718 207.164 83.6435C218.885 84.4152 241.676 87.502 274.234 80.5567C306.791 73.6115 305.869 75.4585 330.233 67.438C388.837 48.1456 433.461 2.6348 458.511 1.07229C495.627 -1.24279 512.557 52.7758 539.255 58.1776C565.952 63.5795 583.534 64.3512 601.766 55.0909C619.999 45.8305 625.859 40.4287 646.045 38.1136C666.231 35.7985 683.812 41.972 718.975 70.5247",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }
) }), ea = m(S)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end"
})), ta = m(S)(() => ({
  position: "relative",
  height: "100%",
  alignSelf: "normal",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end"
})), na = m(S)(({ theme: e }) => ({
  padding: e.spacing(2.25, 0, 0.5, 2)
})), ia = m(xn)(({ theme: e }) => ({
  flexDirection: "column",
  flex: 1,
  height: "100%",
  overflow: "hidden",
  svg: {
    height: "100%",
    width: "100%",
    fontSize: "initial",
    fill: "none",
    path: {
      stroke: e.palette.black[8]
    }
  }
})), ra = m(S)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: e.spacing(1.25, 0.5, 0.75, 0.5)
})), oa = m(S)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  gap: e.spacing(2),
  margin: 0,
  padding: e.spacing(1.5, 1, 0.25, 1)
})), Xt = m(S)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  gap: e.spacing(1)
})), aa = ({
  fitHeight: e,
  height: t,
  showControls: i,
  showLegend: r
}) => /* @__PURE__ */ n(
  Rn,
  {
    fitHeight: !!e,
    header: /* @__PURE__ */ n(S, { pt: 1.25, pb: 0.75, children: /* @__PURE__ */ n(z, { width: 48, height: 8 }) }),
    controls: i && /* @__PURE__ */ v(ea, { children: [
      /* @__PURE__ */ n(S, { p: 0.5, children: /* @__PURE__ */ n(z, { width: 16, height: 16 }) }),
      /* @__PURE__ */ n(S, { mt: 2, p: 0.5, children: /* @__PURE__ */ n(z, { width: 16, height: 16 }) }),
      /* @__PURE__ */ n(S, { mt: 1, p: 0.5, children: /* @__PURE__ */ n(z, { width: 16, height: 16 }) })
    ] }),
    chart: /* @__PURE__ */ v(ta, { style: { height: e ? On : t ?? Pn }, children: [
      /* @__PURE__ */ n(na, { flex: 0, children: /* @__PURE__ */ n(z, { width: 24, height: 8 }) }),
      /* @__PURE__ */ n(ia, { flex: 1, children: /* @__PURE__ */ n(Qo, { preserveAspectRatio: "none" }) }),
      /* @__PURE__ */ v(ra, { flex: 0, children: [
        /* @__PURE__ */ n(z, { width: 32, height: 8 }),
        /* @__PURE__ */ n(z, { width: 32, height: 8 })
      ] })
    ] }),
    legend: r && (r && /* @__PURE__ */ v(oa, { children: [
      /* @__PURE__ */ v(Xt, { children: [
        /* @__PURE__ */ n(z, { width: 8, height: 8 }),
        /* @__PURE__ */ n(z, { width: 48, height: 8 })
      ] }),
      /* @__PURE__ */ v(Xt, { children: [
        /* @__PURE__ */ n(z, { width: 8, height: 8 }),
        /* @__PURE__ */ n(z, { width: 48, height: 8 })
      ] })
    ] }))
  }
), Fn = (e) => e, Nn = [];
function us({
  data: e = Nn,
  categories: t,
  stepSize: i,
  stepMultiplier: r = 1,
  chartType: o = It.LINE,
  timeAxisSplitNumber: a,
  tooltip: l = !0,
  tooltipFormatter: d = En,
  formatter: s = Fn,
  height: u,
  fitHeight: p,
  showControls: c = !0,
  animation: y = !0,
  filterable: g = !0,
  onTimelineUpdate: f,
  timeWindow: w,
  timelinePosition: h,
  onTimeWindowUpdate: b,
  selectedCategories: k,
  onSelectedCategoriesChange: M,
  isPlaying: T = !1,
  onPlay: x,
  isPaused: A = !1,
  onPause: C,
  onStop: O,
  isLoading: L = !1,
  palette: P = Object.values(yn.qualitative.bold),
  showLegend: $,
  yAxisType: W = "dense"
}) {
  const J = re([]), G = se(), { showSkeleton: D } = ke(!!L), N = oe(
    (I) => {
      var R, X;
      if (I.length === 2) {
        ((R = J.current) == null ? void 0 : R.length) === 1 && (f == null || f(void 0));
        const j = I.sort((K, te) => K < te ? -1 : 1).map(Ln);
        b == null || b(j);
      }
      if (I.length === 1) {
        ((X = J.current) == null ? void 0 : X.length) === 2 && (b == null || b([]));
        const j = nt(Number(I[0]), e);
        f == null || f(j);
      }
      J.current = I;
    },
    [b, f, e]
  );
  return D ? /* @__PURE__ */ n(
    aa,
    {
      fitHeight: p,
      height: u,
      showControls: c,
      showLegend: $
    }
  ) : /* @__PURE__ */ n(
    Do,
    {
      isPlaying: T,
      onPlay: x,
      isPaused: A,
      onPause: C,
      onStop: O,
      timeWindow: w,
      onTimeWindowUpdate: N,
      intl: G,
      children: /* @__PURE__ */ n(
        la,
        {
          data: e,
          categories: t,
          stepSize: i,
          stepMultiplier: r,
          chartType: o,
          timeAxisSplitNumber: a,
          tooltip: l,
          tooltipFormatter: d,
          formatter: s,
          height: u,
          fitHeight: p,
          showControls: c,
          animation: y,
          filterable: g,
          palette: P,
          showLegend: $,
          selectedCategories: k,
          timelinePosition: h,
          onSelectedCategoriesChange: M,
          yAxisType: W
        }
      )
    }
  );
}
function la({
  data: e = Nn,
  categories: t,
  stepSize: i,
  stepMultiplier: r = 1,
  chartType: o = It.LINE,
  timeAxisSplitNumber: a,
  tooltip: l = !0,
  tooltipFormatter: d = En,
  formatter: s = Fn,
  height: u,
  fitHeight: p = !1,
  showControls: c = !0,
  animation: y = !0,
  filterable: g = !0,
  palette: f = Object.values(yn.qualitative.bold),
  selectedCategories: w = [],
  onSelectedCategoriesChange: h,
  showLegend: b,
  timelinePosition: k,
  yAxisType: M = "dense"
}) {
  const T = le(), x = T.palette.secondary.main, { isPlaying: A, isPaused: C, timeWindow: O, stop: L, setTimeWindow: P, intl: $ } = Et();
  U(() => {
    if (k !== void 0) {
      if (k < 0 || k >= e.length) return;
      const Y = e[k].name;
      P([Y]);
    }
  }, [k, e]), U(() => {
    if (!e.length) return;
    const Y = e[0].name, Z = e[e.length - 1].name;
    (O[0] < Y || O[1] > Z || O[1] < Y || O[1] > Z) && P([]);
  }, [e]);
  const W = F(() => {
    const Y = {}, Z = t ? t.map((de) => ({
      name: de,
      data: [],
      color: Oi(de, {
        palette: f,
        fallbackColor: x,
        colorMapping: Y
      })
    })) : [
      {
        name: "",
        data: [],
        color: T.palette.secondary.main
      }
    ];
    for (const {
      name: de,
      value: we,
      category: ve,
      categoryIndex: V
    } of e) {
      const ee = V ?? (t && ve ? t.indexOf(ve) : 0);
      ee === -1 || t && ee >= t.length || !Number.isFinite(ee) || Z[ee].data.push([de, we]);
    }
    return Z;
  }, [t, e, f, x, T.palette.secondary.main]), J = F(() => {
    if (!e.length)
      return "";
    if (O.length === 2) {
      const [Y, Z] = O.map((de) => new Date(de));
      return it({ start: Y, end: Z, stepSize: i });
    }
    if (!A && !C) {
      const Y = new Date(e[0].name), Z = new Date(e[e.length - 1].name);
      return it({ start: Y, end: Z, stepSize: i });
    }
    if (O.length === 1) {
      const Y = new Date(O[0]);
      return Dn({ date: Y, stepSize: i, stepMultiplier: r });
    }
  }, [e, O, A, C, i, r]), G = F(() => A || C || O.length > 0 || (w == null ? void 0 : w.length) > 0, [C, A, w == null ? void 0 : w.length, O.length]), D = () => {
    L(), P([]), h == null || h([]);
  }, N = (Y) => {
    Y.key === "Enter" && D();
  }, I = oe(
    (Y) => {
      if (h) {
        const Z = [...w], de = Z.indexOf(Y);
        de === -1 ? Z.push(Y) : Z.splice(de, 1), h(Z);
      }
    },
    [h, w]
  ), R = !!(b ?? W.length > 1), X = /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(S, { children: /* @__PURE__ */ n(H, { color: "textSecondary", variant: "caption", children: J ?? "-" }) }),
    g && G && /* @__PURE__ */ n(
      ye,
      {
        variant: "caption",
        style: { cursor: "pointer" },
        onClick: D,
        onKeyDown: N,
        tabIndex: 0,
        underline: "hover",
        children: $.formatMessage({ id: "c4r.widgets.timeSeries.clear" })
      }
    )
  ] });
  return /* @__PURE__ */ n(
    Rn,
    {
      fitHeight: p,
      header: X,
      controls: g && c && /* @__PURE__ */ n(Bo, { data: e, stepSize: i }),
      chart: /* @__PURE__ */ n(
        Ro,
        {
          chartType: o,
          timeAxisSplitNumber: a,
          data: e,
          series: W,
          categories: t,
          tooltip: l,
          formatter: s,
          tooltipFormatter: (Y) => d(
            Y,
            i,
            s,
            r,
            R
          ),
          height: u,
          fitHeight: p,
          animation: y,
          filterable: g,
          selectedCategories: w,
          onCategoryClick: h && I,
          yAxisType: M
        }
      ),
      legend: R && /* @__PURE__ */ n(
        An,
        {
          series: W,
          selectedCategories: w,
          onCategoryClick: h && I
        }
      )
    }
  );
}
const sa = m("div")(({ theme: e }) => ({
  padding: e.spacing(2, 0),
  ...e.typography.body2
})), ca = m(S)(({ theme: e }) => ({
  overflow: "auto",
  maxHeight: e.spacing(40),
  paddingRight: e.spacing(1),
  margin: e.spacing(0.5, 0)
})), da = m(S)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: e.spacing(1.5),
  padding: e.spacing(2, 0)
})), Bn = m(S)(({ theme: e, alignItems: t = "center" }) => ({
  display: "flex",
  alignItems: t,
  gap: e.spacing(0.75)
})), _n = m("div", {
  shouldForwardProp: (e) => e !== "color"
})(({ theme: e, color: t }) => ({
  flexShrink: 0,
  width: e.spacing(1),
  height: e.spacing(1),
  borderRadius: e.spacing(1),
  backgroundColor: t
})), ua = m(S)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(2)
})), pa = m("div")(({ theme: e }) => ({
  height: e.spacing(0.5),
  width: "100%",
  borderRadius: e.spacing(0.5),
  backgroundColor: e.palette.action.disabledBackground,
  "& div": {
    width: 0,
    height: "100%",
    borderRadius: e.spacing(0.5),
    transition: `background-color ${e.transitions.easing.sharp} ${e.transitions.duration.shortest}ms,
                 width ${e.transitions.easing.sharp} ${e.transitions.duration.complex}ms`
  }
})), qt = m(S, {
  shouldForwardProp: (e) => e !== "center"
})(({ theme: e, center: t = !1 }) => ({
  marginBottom: e.spacing(2),
  paddingRight: e.spacing(1),
  ...t && {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  "& .MuiTypography-caption": {
    color: e.palette.text.secondary
  },
  "& .MuiButton-label": {
    ...e.typography.caption
  },
  "& a": {
    cursor: "pointer"
  }
})), ga = m(ue)(({ theme: e }) => ({
  ".MuiTooltip-tooltip": {
    color: e.palette.common.white,
    maxWidth: 260,
    marginBottom: 0,
    overflow: "hidden"
  }
})), ha = m(ot)(({ theme: e }) => ({
  marginTop: e.spacing(-0.5)
}));
m(S)(() => ({
  display: "flex",
  flexWrap: "nowrap",
  justifyContent: "space-between"
}));
const fa = m("div", {
  shouldForwardProp: (e) => e !== "filterable"
})(({ filterable: e }) => ({
  "& .progressbar div": {
    backgroundColor: "var(--color)"
  },
  ...e && {
    cursor: "pointer",
    "& .MuiBox-root:hover .progressbar div": {
      backgroundColor: "var(--hover-color)"
    }
  }
})), ma = m(S)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  overflow: "hidden",
  gap: e.spacing(1)
})), ya = m(S)(({ theme: e }) => ({
  padding: e.spacing(0.5, 0),
  flexGrow: "1",
  maxWidth: "100%",
  minWidth: 0
})), wa = m(S, {
  shouldForwardProp: (e) => e !== "backgroundColor"
})(({ theme: e, backgroundColor: t }) => ({
  marginLeft: e.spacing(1),
  padding: e.spacing(0, 1),
  backgroundColor: t,
  color: "white",
  borderRadius: e.spacing(2)
}));
function va(e, t, i, r, o) {
  const l = (e[0] ?? []).map((d, s) => {
    const u = String(d.name), p = r.length > 0 && !r.includes(u), c = i[s] ?? u, y = e.map((g, f) => {
      var w;
      return {
        color: p ? pn(t[f], 0.8) : t[f],
        value: ((w = g[s]) == null ? void 0 : w.value) ?? 0
      };
    });
    return {
      label: c,
      key: u,
      data: y
    };
  });
  return o === Te.RANKING && l.sort((d, s) => {
    const u = Math.max(...d.data.map((c) => c.value));
    return Math.max(...s.data.map((c) => c.value)) - u;
  }), l;
}
const xa = 500;
function ba(e, t = {}) {
  const { disabled: i, duration: r, animateOnMount: o, initialValue: a = 0 } = t, l = re(null), [d, s] = _(
    () => o ? a : e
  );
  return U(() => (i ? s(e) : gt({
    start: d,
    end: e,
    duration: r ?? xa,
    drawFrame: (u) => s(u),
    requestRef: l
  }), () => {
    l.current && cancelAnimationFrame(l.current);
  }), [e, i, r]), d;
}
const ka = {};
function Hn({
  enabled: e = !0,
  value: t = 0,
  options: i = ka,
  formatter: r
}) {
  const a = ba(t || 0, {
    ...{
      animateOnMount: !0,
      disabled: e === !1 || t === null || t === void 0
    },
    ...i
  });
  return /* @__PURE__ */ n("span", { children: r ? r(a) : a });
}
const mt = (e) => e, Sa = () => {
}, Ma = [];
function Ia({
  item: e,
  index: t = 0,
  names: i = Ma,
  formatter: r = mt
}) {
  const o = le(), a = e.data[0], l = e.data[t], d = i[t], s = (l.value - a.value) / (a.value || 1) * 100, u = Math.sign(s) === -1 ? "-" : "+", p = Math.sign(s) === -1 ? o.palette.error.main : o.palette.success.main, c = e.key === Oe ? o.palette.text.disabled : p;
  return /* @__PURE__ */ v("div", { children: [
    /* @__PURE__ */ n(De, { color: "inherit", variant: "caption", noWrap: !0, children: e.label }),
    /* @__PURE__ */ n(S, { pt: 1, pb: 0.5, children: /* @__PURE__ */ v(Bn, { alignItems: "baseline", children: [
      /* @__PURE__ */ n(
        _n,
        {
          color: e.key === Oe ? o.palette.background.default : l.color
        }
      ),
      /* @__PURE__ */ n(De, { color: "inherit", variant: "caption", children: d }),
      /* @__PURE__ */ n(S, { style: { flexGrow: 1 } }),
      /* @__PURE__ */ n(wa, { backgroundColor: c, children: /* @__PURE__ */ v(De, { color: "inherit", variant: "caption", children: [
        u,
        r(Math.abs(s))
      ] }) })
    ] }) })
  ] });
}
function Ta({
  item: e,
  animation: t = !0,
  animationOptions: i,
  maxValue: r,
  showCheckbox: o,
  checkboxChecked: a,
  formatter: l = mt,
  tooltipFormatter: d = mt,
  onClick: s = Sa,
  names: u,
  tooltip: p
}) {
  function c(g) {
    return `${Math.min(100, (g || 0) / r * 100)}%`;
  }
  const y = (g) => /* @__PURE__ */ n(
    Ia,
    {
      item: e,
      names: u,
      formatter: d,
      index: g
    }
  );
  return /* @__PURE__ */ v(ma, { onClick: () => s(e.key), children: [
    o ? /* @__PURE__ */ n(ln, { checked: a }) : null,
    /* @__PURE__ */ v(ya, { children: [
      /* @__PURE__ */ n(De, { variant: "body2", noWrap: !0, children: e.label }),
      e.data.map((g, f) => /* @__PURE__ */ n(
        ga,
        {
          title: y(f),
          placement: "top-start",
          arrow: !1,
          disableHoverListener: !p,
          children: /* @__PURE__ */ v(ua, { children: [
            /* @__PURE__ */ n(pa, { className: "progressbar", children: /* @__PURE__ */ n(
              "div",
              {
                style: {
                  "--hover-color": yt(g.color, 0.2),
                  "--color": g.color,
                  width: c(g.value)
                }
              }
            ) }),
            /* @__PURE__ */ n(
              De,
              {
                variant: f === 0 ? "body2" : "caption",
                color: f === 0 ? "textPrimary" : "textSecondary",
                children: /* @__PURE__ */ n(
                  Hn,
                  {
                    value: g.value,
                    enabled: t,
                    options: i,
                    formatter: l
                  }
                )
              }
            )
          ] })
        },
        `${e.key}_${f}`
      ))
    ] })
  ] });
}
const Kt = (e) => e, Ca = () => {
}, He = [];
function ps({
  names: e = He,
  data: t = He,
  labels: i = He,
  colors: r = He,
  maxItems: o = 5,
  order: a = Te.FIXED,
  animation: l = !0,
  animationOptions: d,
  searchable: s = !0,
  filterable: u = !0,
  selectedCategories: p = He,
  onSelectedCategoriesChange: c = Ca,
  formatter: y = Kt,
  tooltipFormatter: g = Kt,
  tooltip: f = !0,
  isLoading: w = !1
}) {
  const h = le(), [b, k] = _(!1), [M, T] = _(!1), [x, A] = _(p), [C, O] = _(""), L = se(), P = ce(L), $ = F(() => {
    const V = r.length ? r : [
      h.palette.secondary.main,
      h.palette.primary.main,
      h.palette.info.main
    ];
    return va(
      t,
      V,
      i,
      p,
      a
    );
  }, [t, r, i, h, p, a]), W = F(() => Math.max(
    ...t.map((V) => V.map((ee) => ee.value ?? 0)).flat()
  ), [t]), J = F(() => {
    if (o >= $.length)
      return $;
    const V = $.slice(0, o), ee = $.slice(o), ne = [];
    for (const Ce of ee)
      Ce.data.forEach((Re, Ae) => {
        ne[Ae] = ne[Ae] ?? 0, ne[Ae] += Re.value;
      });
    const pe = {
      key: Oe,
      label: s ? "Others" : `Others (${$.length - o})`,
      data: ne.map((Ce) => ({
        value: Ce,
        color: h.palette.divider
      }))
    };
    return [...V, pe];
  }, [$, s, o, h.palette.divider]), G = F(() => $.filter((V) => p.includes(V.key)), [$, p]), D = F(() => C ? $.filter((V) => {
    const ee = (V.key || "").toLowerCase(), ne = (V.label || "").toLowerCase(), pe = ee == null ? void 0 : ee.includes(C.toLowerCase()), Ce = ne == null ? void 0 : ne.includes(C.toLowerCase());
    return pe || Ce;
  }) : $, [$, C]), N = $.length - J.length + 1, I = s && !b && o < $.length;
  if ($.length === 0 || w)
    return /* @__PURE__ */ n(Mn, {});
  const R = b ? D : M ? G : J;
  function X() {
    T(!0), c([...x]), Z();
  }
  function j() {
    T(!1);
  }
  function K() {
    c([]);
  }
  function te() {
    T(!0);
  }
  function Y() {
    k(!0), A([...p]);
  }
  function Z() {
    k(!1), A([]);
  }
  function de(V) {
    const ee = p.includes(V), ne = new Set(p);
    ee ? ne.delete(V) : ne.add(V);
    let pe = Array.from(ne);
    pe.length === $.length && (pe = []), c(pe);
  }
  function we(V) {
    const ee = x.includes(V), ne = new Set(x);
    ee ? ne.delete(V) : ne.add(V);
    let pe = Array.from(ne);
    pe.length === $.length && (pe = []), A(pe);
  }
  const ve = u ? b ? we : de : void 0;
  return /* @__PURE__ */ v(sa, { children: [
    u ? /* @__PURE__ */ v(qt, { center: !0, children: [
      /* @__PURE__ */ n(H, { variant: "caption", children: p.length > 0 ? P.formatMessage(
        { id: "c4r.widgets.category.selectedItems" },
        { items: p.length }
      ) : P.formatMessage({ id: "c4r.widgets.category.all" }) }),
      /* @__PURE__ */ n(H, { variant: "caption", component: "div", children: b ? /* @__PURE__ */ n(ye, { onClick: X, children: P.formatMessage({ id: "c4r.widgets.category.apply" }) }) : M ? /* @__PURE__ */ n(ye, { onClick: j, children: P.formatMessage({
        id: "c4r.widgets.category.unlock"
      }) }) : p.length ? /* @__PURE__ */ v(
        S,
        {
          style: {
            display: "flex",
            justifyContent: "flex-end",
            gap: h.spacing(1)
          },
          children: [
            /* @__PURE__ */ n(ye, { onClick: te, children: P.formatMessage({
              id: "c4r.widgets.category.lock"
            }) }),
            /* @__PURE__ */ n(wt, { orientation: "vertical", flexItem: !0 }),
            /* @__PURE__ */ n(ye, { onClick: K, children: P.formatMessage({
              id: "c4r.widgets.category.clear"
            }) })
          ]
        }
      ) : null })
    ] }) : null,
    b ? /* @__PURE__ */ n(qt, { children: /* @__PURE__ */ n(
      ha,
      {
        size: "small",
        placeholder: P.formatMessage({
          id: "c4r.widgets.category.search"
        }),
        onChange: (V) => O(V.currentTarget.value),
        onFocus: (V) => V.currentTarget.scrollIntoView(),
        InputProps: {
          startAdornment: /* @__PURE__ */ n(vt, { position: "start", children: /* @__PURE__ */ n(Qe, {}) })
        }
      }
    ) }) : null,
    /* @__PURE__ */ v(ca, { children: [
      R.length === 0 ? /* @__PURE__ */ v(ie, { children: [
        /* @__PURE__ */ n(H, { variant: "body2", children: P.formatMessage({
          id: "c4r.widgets.category.noResults"
        }) }),
        /* @__PURE__ */ n(H, { variant: "caption", children: P.formatMessage(
          { id: "c4r.widgets.category.noResultsMessage" },
          { searchValue: C }
        ) })
      ] }) : null,
      R.map((V) => /* @__PURE__ */ n(fa, { children: /* @__PURE__ */ n(
        Ta,
        {
          item: V,
          animation: l,
          animationOptions: d,
          maxValue: W,
          showCheckbox: u && b,
          checkboxChecked: x.includes(V.key),
          formatter: y,
          tooltipFormatter: g,
          tooltip: f,
          onClick: ve,
          names: e
        }
      ) }, V.key))
    ] }),
    I ? /* @__PURE__ */ n(
      $e,
      {
        size: "small",
        color: "primary",
        startIcon: /* @__PURE__ */ n(Qe, {}),
        onClick: Y,
        children: P.formatMessage(
          { id: "c4r.widgets.category.searchInfo" },
          { elements: N }
        )
      }
    ) : null,
    b ? /* @__PURE__ */ n($e, { size: "small", color: "primary", onClick: Z, children: P.formatMessage({ id: "c4r.widgets.category.cancel" }) }) : null,
    /* @__PURE__ */ n(da, { children: e.map((V, ee) => /* @__PURE__ */ v(Bn, { children: [
      /* @__PURE__ */ n(_n, { color: (r == null ? void 0 : r[ee]) ?? h.palette.background.default }),
      /* @__PURE__ */ n(H, { variant: "overline", children: V })
    ] }, e[ee])) })
  ] });
}
const Aa = m(H)(({ theme: e }) => ({
  display: "inline-block",
  marginTop: e.spacing(0.5)
}));
function Ea({
  row: e
}) {
  const t = le();
  return e.label ? /* @__PURE__ */ n(S, { color: e.color ?? t.palette.text.secondary, children: /* @__PURE__ */ n(Aa, { color: "inherit", variant: "caption", children: e.label }) }) : null;
}
const La = m("div")(({ theme: e }) => ({
  margin: 0,
  ...e.typography.h5,
  fontWeight: Number(e.typography.fontWeightMedium),
  color: e.palette.text.primary,
  display: "flex"
})), Da = m(H)(({ theme: e }) => ({
  marginRight: e.spacing(0.5)
})), $a = m(H)(({ theme: e }) => ({
  marginLeft: e.spacing(0.5)
}));
function Pa({
  row: e,
  animated: t,
  animationOptions: i,
  formatter: r
}) {
  const o = le(), { prefix: a, value: l, suffix: d, shouldBeHighlighted: s } = e;
  return /* @__PURE__ */ v(La, { children: [
    a ? /* @__PURE__ */ n(S, { color: o.palette.text.secondary, children: /* @__PURE__ */ n(Da, { color: "inherit", component: "span", variant: "subtitle2", children: a }) }) : null,
    /* @__PURE__ */ n(S, { fontWeight: s ? "bold" : "", children: /* @__PURE__ */ n(
      Hn,
      {
        value: l,
        enabled: t,
        options: i,
        formatter: r
      }
    ) }),
    d ? /* @__PURE__ */ n(S, { color: o.palette.text.secondary, children: /* @__PURE__ */ n($a, { color: "inherit", component: "span", variant: "subtitle2", children: d }) }) : null
  ] });
}
const Oa = (e) => e, Zt = [], Wa = m("div")(({ theme: e }) => ({
  "&:nth-of-type(n+2)": {
    marginTop: e.spacing(2)
  }
}));
function gs({
  data: e = Zt,
  colors: t = Zt,
  animated: i = !0,
  animationOptions: r,
  formatter: o = Oa,
  isLoading: a = !1
}) {
  const l = Ra(e, t);
  return a ? /* @__PURE__ */ n(Tn, {}) : /* @__PURE__ */ n("div", { children: l.map((d, s) => /* @__PURE__ */ v(Wa, { children: [
    /* @__PURE__ */ n(
      Pa,
      {
        row: d,
        animated: i,
        animationOptions: r,
        formatter: o
      }
    ),
    /* @__PURE__ */ n(Ea, { row: d })
  ] }, s)) });
}
function Ra(e, t) {
  const i = e.map((o, a) => ({ ...o, color: t[a], shouldBeHighlighted: !1 })).filter((o) => o.value !== void 0);
  return i && i.length > 1 && (i[0].shouldBeHighlighted = !0), i;
}
function Fa(e, t = [], i = [], r, o = []) {
  return e.map((a, l) => {
    const d = o.length > 0 && !o.includes(a.name), u = (t != null && t.length ? t : r.palette.qualitative.bold)[l];
    return {
      ...a,
      key: a.name,
      color: d ? pn(u, 0.8) : u,
      name: i[l] ?? a.name
    };
  });
}
function Na(e, t, i) {
  const r = `
    font-size: 12px;
    line-height: 1.33;
    font-weight: 600;
    margin: 4px 0 4px 0;
  `, o = `
    font-size: 12px;
    line-height: 1.33;
    font-weight: normal;
    margin: 0 0 4px 0;
  `, a = Array.isArray(e) ? e[0] : e;
  if (!a)
    return null;
  const l = a.data, d = t(l.value), s = i ? a.seriesName : d, u = t(a.percent);
  return `
    <p style="${r}">${l.name}</p>
    <p style="${o}">${String(a.marker)} ${s} (${u} %)</p>
  `.trim();
}
const Ba = (e) => e, _a = () => {
}, Ke = [], Ha = "260px";
function hs({
  names: e = Ke,
  data: t = Ke,
  labels: i = Ke,
  colors: r = Ke,
  height: o = Ha,
  animation: a = !0,
  formatter: l = Ba,
  tooltipFormatter: d = Na,
  selectedCategories: s = [],
  onCategorySelected: u = _a,
  isLoading: p = !1
}) {
  const c = le(), y = re(), g = F(() => t.map(
    (b, k) => Fa(b, r[k], i[k], c, s)
  ), [t, r, i, c, s]), f = F(() => {
    const b = g.length > 1;
    let k;
    d && (k = (L) => d(L, l, b));
    const M = {
      trigger: "item",
      show: !0,
      backgroundColor: c.palette.black[90],
      textStyle: { color: c.palette.common.white },
      confine: !0,
      borderWidth: 0,
      formatter: k
    }, x = {
      data: b ? g.map((L, P) => e[P]) : (g[0] ?? []).map((L) => L.name),
      selectedMode: !1,
      type: "scroll",
      left: B,
      bottom: B * -0.5,
      itemGap: B * 3,
      icon: "circle",
      itemWidth: B,
      itemHeight: B,
      textStyle: {
        ...c.typography.overline,
        color: c.palette.text.primary,
        fontWeight: 400,
        lineHeight: 1,
        verticalAlign: "bottom",
        padding: [0, 0, 0, B * 0.5]
      },
      inactiveColor: c.palette.text.disabled,
      pageIcons: {
        horizontal: [
          "path://M15.41 7.41 14 6 8 12 14 18 15.41 16.59 10.83 12z",
          "path://M9 16.59 13.3265857 12 9 7.41 10.3319838 6 16 12 10.3319838 18z"
        ]
      },
      pageIconSize: B * 1.5,
      pageIconColor: c.palette.text.secondary,
      pageIconInactiveColor: c.palette.text.disabled,
      pageTextStyle: {
        fontFamily: c.typography.overline.fontFamily,
        fontSize: B * 1.5,
        lineHeight: B * 1.75,
        fontWeight: 400,
        color: c.palette.text.primary
      }
    }, A = {
      formatter: ({ name: L, percent: P }) => `{per|${l(P)}%}
{b|${L}}`,
      position: "center",
      rich: {
        b: {
          fontFamily: c.typography.overline.fontFamily,
          fontSize: B * 1.75,
          lineHeight: B * 1.75,
          fontWeight: 400,
          color: c.palette.text.primary
        },
        per: {
          ...c.typography.overline,
          fontSize: B * 3,
          lineHeight: B * 4.5,
          fontWeight: 600,
          color: c.palette.text.primary
        }
      }
    }, C = g.map((L, P) => {
      var $;
      return {
        type: "pie",
        name: e[P],
        itemStyle: {
          color: ($ = L[0]) == null ? void 0 : $.color
        },
        animation: a,
        data: L.map((W) => ({ ...W, itemStyle: { color: W.color } })),
        radius: P === 0 ? ["75%", "90%"] : ["56%", "72%"],
        selectedOffset: 0,
        hoverOffset: 5,
        bottom: B * 2.5,
        avoidLabelOverlap: !0,
        label: { show: !1, ...A },
        emphasis: {
          label: {
            show: !0,
            formatter: A.formatter,
            rich: A.rich
          }
        }
      };
    });
    return { grid: {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    }, tooltip: M, legend: x, series: C };
  }, [c, e, a, g, l, d]), w = {
    mouseover: (b, k) => {
      g.length === 1 && (b.seriesIndex !== 0 || b.dataIndex !== 0) && k.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: 0
      });
    },
    mouseout: (b, k) => {
      g.length === 1 && k.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: 0
      });
    },
    click: (b) => {
      const M = g[b.seriesIndex][b.dataIndex].key, T = s.includes(M), x = new Set(s);
      T ? x.delete(M) : x.add(M);
      const A = g[0].length;
      let C = Array.from(x);
      C.length === A && (C = []), u(C);
    }
  };
  U(() => {
    y.current && y.current.dispatchAction({
      type: g.length === 1 ? "highlight" : "downplay",
      seriesIndex: 0,
      dataIndex: 0
    });
  }, [g]);
  function h(b) {
    y.current = b;
  }
  return g.length ? p ? /* @__PURE__ */ n(Cn, { height: o }) : /* @__PURE__ */ n(
    We,
    {
      onChartReady: h,
      notMerge: !0,
      option: f,
      onEvents: w,
      style: { maxHeight: o, width: "100%" }
    }
  ) : null;
}
const za = () => {
};
function ja({
  icon: e,
  hoverTooltip: t,
  clickTooltip: i,
  enabled: r,
  onEnabledChange: o = za,
  tooltipPlacement: a = "bottom"
}) {
  const [l, d] = _(!1), [s, u] = _(r);
  return U(() => {
    u(r);
  }, [r]), U(() => {
    if (r) {
      const c = (y) => {
        y.key === "Escape" && o && o(!1);
      };
      return window.addEventListener("keydown", c), () => {
        window.removeEventListener("keydown", c);
      };
    }
  }, [r, o]), /* @__PURE__ */ n(li, { onClickAway: () => u(!1), children: /* @__PURE__ */ n(
    ue,
    {
      title: s ? i : t,
      placement: a,
      open: l,
      onOpen: () => d(!0),
      onClose: () => {
        s || d(!1);
      },
      children: /* @__PURE__ */ n(
        si,
        {
          value: "selectedMode",
          selected: r,
          onClick: () => o && o(!r),
          children: e
        }
      )
    }
  ) });
}
const Ya = m(fe, {
  shouldForwardProp: (e) => e !== "isOpen"
})(({ isOpen: e, theme: t }) => ({
  color: t.palette.text.secondary,
  width: t.spacing(3),
  transform: `rotate(${e ? "180" : "0"}deg)`,
  backgroundColor: e ? t.palette.action.hover : void 0
})), Va = m(Pe, {
  shouldForwardProp: (e) => e !== "disabled"
})(({ disabled: e, theme: t }) => ({
  ...e && {
    pointerEvents: "none",
    color: t.palette.text.disabled
  }
})), Ga = m(Pe)(() => ({
  "&.Mui-disabled": {
    opacity: 1
  }
})), Ua = () => {
};
function Xa({
  selectionModes: e,
  editModes: t,
  selectedMode: i,
  onSelectMode: r = Ua,
  enabled: o,
  tooltipPlacement: a = "bottom",
  tooltipText: l = "",
  menuHeaderText: d = "",
  editDisabled: s
}) {
  const u = le(), [p, c] = _(null), y = !!p, g = (M) => c(M.currentTarget), f = () => c(null), w = (M) => {
    r && r(M), f();
  }, h = !!e.length && !!t.length, b = (M) => t.some((T) => T.id === M.id);
  function k(M) {
    return /* @__PURE__ */ n(
      Va,
      {
        selected: o && i === M.id,
        onClick: () => w(M.id),
        disabled: s && b(M),
        children: /* @__PURE__ */ v(S, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [
          M.icon,
          /* @__PURE__ */ n(S, { ml: 2, children: /* @__PURE__ */ n(H, { variant: "body2", color: "inherit", children: gn(M.label) }) })
        ] })
      },
      M.id
    );
  }
  return /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(ue, { title: l, placement: a, children: /* @__PURE__ */ n(
      Ya,
      {
        id: "feature-selection-menu-button",
        "aria-controls": "feature-selection-menu",
        "aria-haspopup": "true",
        "aria-expanded": y ? "true" : void 0,
        onClick: g,
        isOpen: y,
        children: /* @__PURE__ */ n(Ii, {})
      }
    ) }),
    /* @__PURE__ */ v(
      kt,
      {
        id: "feature-selection-menu",
        style: { zIndex: u.zIndex.tooltip + 1 },
        anchorEl: p,
        open: y,
        onClose: f,
        MenuListProps: { "aria-labelledby": "feature-selection-menu-button" },
        children: [
          d && /* @__PURE__ */ n(Ga, { disabled: !0, children: /* @__PURE__ */ n(H, { variant: "caption", color: "textSecondary", children: d }) }),
          !!e.length && e.map(k),
          h && /* @__PURE__ */ n(wt, { sx: { margin: ({ spacing: M }) => M(1, 0) } }),
          !!t.length && t.map(k)
        ]
      }
    )
  ] });
}
const qa = m(ui)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  marginLeft: e.spacing(1.5),
  padding: e.spacing(0.5),
  overflowX: "auto",
  maxWidth: "100%",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none"
  }
})), Ka = () => {
};
function Za({
  features: e,
  onSelectGeometry: t = Ka,
  onDeleteGeometry: i,
  chipTooltip: r,
  disabledChipTooltip: o,
  size: a = "medium",
  tooltipPlacement: l = "bottom",
  chipLabel: d
}) {
  const s = se(), u = ce(s);
  function p(f) {
    return f === "MultiPoint" ? u.formatMessage({
      id: "c4r.widgets.featureSelection.point"
    }) : f === "MultiLineString" ? u.formatMessage({
      id: "c4r.widgets.featureSelection.lineString"
    }) : f === "MultiPolygon" || f === "Polygon" || f === "GeometryCollection" ? u.formatMessage({
      id: "c4r.widgets.featureSelection.polygon"
    }) : f;
  }
  function c(f, w) {
    var b;
    const h = p(f.geometry.type);
    return d || ((b = f.properties) == null ? void 0 : b.name) || `${h} ${w + 1}`;
  }
  const [y, g] = _(!1);
  return /* @__PURE__ */ n(S, { sx: { overflowX: "auto" }, children: /* @__PURE__ */ n(qa, { sx: { gap: a === "small" ? 0.5 : 1 }, children: e.map((f, w) => {
    var T, x;
    const h = (T = f.properties) == null ? void 0 : T.disabled, b = (x = f.properties) == null ? void 0 : x.invalid;
    let k = r;
    h && (k = o || r), b && (k = u.formatMessage({
      id: "c4r.widgets.featureSelection.invalid"
    })), y && (k = u.formatMessage({
      id: "c4r.widgets.featureSelection.remove"
    }));
    let M = "secondary";
    return h && (M = "default"), b && (M = "error"), /* @__PURE__ */ n(ci, { disablePadding: !0, children: /* @__PURE__ */ n(
      ue,
      {
        disableHoverListener: h ? !o : !r,
        title: k,
        placement: l,
        children: /* @__PURE__ */ n(
          di,
          {
            size: a,
            label: c(f, w),
            color: M,
            onClick: () => t(f),
            onDelete: i ? () => i(f) : void 0,
            icon: b ? /* @__PURE__ */ n(Ti, { color: "error" }) : void 0,
            deleteIcon: /* @__PURE__ */ n(
              Ci,
              {
                onMouseEnter: () => g(!0),
                onMouseLeave: () => g(!1)
              }
            )
          }
        )
      }
    ) }, w);
  }) }) });
}
const Ja = m(hn)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  maxHeight: e.spacing(5),
  padding: e.spacing(0.5)
})), Qa = [];
function fs({
  selectionModes: e,
  editModes: t = Qa,
  selectedMode: i,
  onSelectMode: r,
  enabled: o = !1,
  onEnabledChange: a,
  geometry: l,
  onSelectGeometry: d,
  onDeleteGeometry: s,
  tooltipPlacement: u = "bottom",
  size: p = "medium",
  chipLabel: c
}) {
  const y = se(), g = ce(y), f = F(() => e.map((T) => ({
    ...T,
    label: g.formatMessage({
      id: `c4r.widgets.featureSelection.${Jt(T.id)}`
    })
  })), [e, g]), w = F(() => t.map((T) => ({
    ...T,
    label: g.formatMessage({
      id: `c4r.widgets.featureSelection.${Jt(T.id)}`
    })
  })), [t, g]), h = F(() => {
    const x = [
      ...f.map((A) => ({
        ...A,
        isEdit: !1
      })),
      ...w.map((A) => ({
        ...A,
        isEdit: !0
      }))
    ].find((A) => A.id === i);
    if (!x)
      throw new Error(`Selected mode "${i}" not supported`);
    return x;
  }, [w, f, i]), b = gn((h == null ? void 0 : h.label) || ""), k = h != null && h.isEdit ? b : g.formatMessage(
    {
      id: "c4r.widgets.featureSelection.selectTool"
    },
    { label: b }
  ), M = h != null && h.isEdit ? g.formatMessage({
    id: "c4r.widgets.featureSelection.clickToEdit"
  }) : g.formatMessage({
    id: "c4r.widgets.featureSelection.clickToCreate"
  });
  return /* @__PURE__ */ v(Ja, { children: [
    /* @__PURE__ */ n(
      ja,
      {
        icon: h == null ? void 0 : h.icon,
        hoverTooltip: k,
        clickTooltip: M,
        enabled: o,
        onEnabledChange: a,
        tooltipPlacement: u
      }
    ),
    /* @__PURE__ */ n(
      Xa,
      {
        selectionModes: f,
        editModes: w,
        selectedMode: i,
        onSelectMode: r,
        enabled: o,
        tooltipPlacement: u,
        tooltipText: g.formatMessage({
          id: "c4r.widgets.featureSelection.selectMode"
        }),
        menuHeaderText: g.formatMessage({
          id: "c4r.widgets.featureSelection.chooseSelectionMode"
        }),
        editDisabled: !l
      }
    ),
    !!l && /* @__PURE__ */ n(
      Za,
      {
        features: [l],
        onSelectGeometry: d,
        onDeleteGeometry: s,
        disabledChipTooltip: g.formatMessage({
          id: "c4r.widgets.featureSelection.applyMask"
        }),
        chipTooltip: g.formatMessage({
          id: "c4r.widgets.featureSelection.clearMask"
        }),
        tooltipPlacement: u,
        size: p,
        chipLabel: c
      }
    )
  ] });
}
function Jt(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
const zn = 240, el = m(hn, {
  shouldForwardProp: (e) => e !== "collapsed"
})(({ theme: e, collapsed: t }) => ({
  width: t ? "min-content" : zn,
  background: e.palette.background.paper,
  maxHeight: "calc(100% - 120px)",
  display: "flex",
  flexDirection: "column"
})), tl = m("header", {
  shouldForwardProp: (e) => e !== "collapsed"
})(({ theme: e, collapsed: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: e.spacing(1),
  paddingLeft: e.spacing(2),
  borderBottom: t ? void 0 : `1px solid ${e.palette.divider}`
})), nl = m("header")(({ theme: e }) => ({
  padding: e.spacing(1.5),
  paddingRight: e.spacing(2),
  gap: e.spacing(0.5),
  display: "flex",
  justifyContent: "space-between",
  position: "sticky",
  zIndex: 2,
  top: 0,
  background: e.palette.background.paper
})), il = m("div")(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(2),
  alignItems: "center",
  padding: e.spacing(1),
  minWidth: `calc(${zn}px - ${e.spacing(4)})`
})), rl = m(ot)(({ theme: e }) => ({
  display: "flex",
  width: e.spacing(7.5),
  flexShrink: 0,
  "input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0
  }
})), ol = m("ul", {
  shouldForwardProp: (e) => e !== "opacity"
})(({ theme: e, opacity: t }) => ({
  opacity: t,
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(1)
})), jn = m("ul")(({ theme: e }) => ({
  margin: 0,
  padding: 0,
  paddingBottom: e.spacing(1),
  display: "flex",
  flexDirection: "column"
})), al = m("li")(() => ({
  display: "flex",
  alignItems: "center"
})), ll = m("div")(({ theme: e }) => ({
  marginRight: e.spacing(1.5),
  width: pt,
  height: pt,
  "& img": {
    margin: "auto",
    display: "block"
  }
})), Qt = m(S, {
  shouldForwardProp: (e) => e !== "width"
})(({ width: e, theme: t }) => ({
  width: e,
  overflow: "auto",
  maxHeight: `calc(100% - ${t.spacing(1.5)})`
})), sl = m("section")(({ theme: e }) => ({
  "&:not(:first-of-type)": {
    borderTop: `1px solid ${e.palette.divider}`
  }
})), cl = m("div")(() => ({
  flexGrow: 1,
  flexShrink: 1,
  minWidth: 0
}));
function dl({
  menuRef: e,
  open: t,
  toggleOpen: i,
  opacity: r,
  onChange: o
}) {
  const a = se(), l = ce(a);
  function d(s) {
    const u = parseInt(s.target.value || "0"), p = Math.min(Math.max(u, 0), 100);
    o(p / 100);
  }
  return /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(
      ue,
      {
        title: l.formatMessage({ id: "c4r.widgets.legend.opacity" }),
        children: /* @__PURE__ */ n(
          fe,
          {
            size: "small",
            color: t ? "primary" : "default",
            onClick: () => i(!t),
            children: /* @__PURE__ */ n(ki, {})
          }
        )
      }
    ),
    /* @__PURE__ */ n(
      pi,
      {
        open: t,
        onClose: () => i(!1),
        anchorEl: e.current,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        slotProps: {
          root: {
            sx: { transform: "translate(-12px, 36px)" }
          }
        },
        children: /* @__PURE__ */ v(il, { children: [
          /* @__PURE__ */ n(
            xt,
            {
              value: r * 100,
              onChange: (s, u) => o(u / 100),
              min: 0,
              max: 100,
              step: 1
            }
          ),
          /* @__PURE__ */ n(
            rl,
            {
              size: "small",
              type: "number",
              value: Math.round(r * 100),
              onChange: d,
              inputProps: {
                step: 1,
                min: 0,
                max: 100,
                style: { appearance: "textfield" },
                "data-testid": "opacity-slider"
              },
              InputProps: {
                endAdornment: /* @__PURE__ */ v(vt, { position: "end", sx: { margin: 0 }, children: [
                  " ",
                  "%"
                ] })
              }
            }
          )
        ] })
      }
    )
  ] });
}
function Lt({
  title: e,
  visible: t
}) {
  const i = re(null), [r, o] = _(!1);
  an(() => {
    if (t && i.current) {
      const { offsetWidth: l, scrollWidth: d } = i.current;
      o(l < d);
    }
  }, [e, t]);
  const a = /* @__PURE__ */ n(
    H,
    {
      ref: i,
      color: t ? "textPrimary" : "textSecondary",
      variant: "caption",
      weight: "regular",
      component: "p",
      noWrap: !0,
      my: 0.25,
      textTransform: "none",
      children: e
    }
  );
  return r ? /* @__PURE__ */ n(ue, { title: e, children: a }) : a;
}
var Ie = /* @__PURE__ */ ((e) => (e.CATEGORY = "category", e.ICON = "icon", e.CONTINUOUS_RAMP = "continuous_ramp", e.BINS = "bins", e.PROPORTION = "proportion", e))(Ie || {});
const ut = 20;
function ul({
  legend: e
}) {
  const {
    labels: t = [],
    colors: i = [],
    isStrokeColor: r = !1,
    customMarkers: o,
    maskedMarkers: a = !0
  } = e, l = wn(i, t.length), d = t.length > ut, s = se(), u = ce(s);
  return /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(jn, { "data-testid": "categories-legend", children: t.slice(0, ut).map((p, c) => /* @__PURE__ */ n(
      fl,
      {
        label: String(p),
        color: l[c % l.length],
        icon: o && Array.isArray(o) ? o[c] : o,
        maskedIcon: a,
        isStrokeColor: r
      },
      `${p}${c}`
    )) }),
    d && /* @__PURE__ */ n(
      H,
      {
        variant: "caption",
        color: "textSecondary",
        component: "div",
        py: 2,
        children: u.formatMessage(
          {
            id: "c4r.widgets.legend.maxCategories"
          },
          {
            n: ut
          }
        )
      }
    )
  ] });
}
const pl = ({
  isMax: e,
  color: t,
  isStrokeColor: i,
  theme: r
}) => ({
  border: "2px solid transparent",
  "&::after": {
    position: "absolute",
    display: e ? "block" : "none",
    content: '""',
    width: r.spacing(2),
    height: r.spacing(2),
    border: `2px solid ${r.palette.grey[900]}`,
    transform: "translate(-30%, -30%)",
    borderRadius: "50%",
    boxSizing: "content-box"
  },
  ...i ? { borderColor: t } : { backgroundColor: t }
}), gl = ({
  icon: e,
  color: t,
  maskedIcon: i
}) => ({
  maskRepeat: "no-repeat",
  maskSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  ...i ? {
    backgroundColor: t,
    maskImage: `url(${e})`,
    WebkitMaskImage: `url(${e})`
  } : {
    backgroundColor: "rgba(0,0,0,0)",
    backgroundImage: `url(${e})`
  }
}), hl = m(S, {
  shouldForwardProp: (e) => e !== "icon" && e !== "maskedIcon" && e !== "color" && e !== "isStrokeColor"
})(({ icon: e, maskedIcon: t, color: i, isStrokeColor: r, theme: o }) => ({
  whiteSpace: "nowrap",
  display: "block",
  width: o.spacing(1.5),
  height: o.spacing(1.5),
  flexShrink: "0",
  borderRadius: "50%",
  position: "relative",
  border: "2px solid transparent",
  ...e ? gl({ icon: e, color: i, maskedIcon: t }) : pl({ color: i, isStrokeColor: r, theme: o })
}));
function fl({
  label: e,
  isStrokeColor: t,
  color: i = "#000",
  icon: r,
  maskedIcon: o
}) {
  return /* @__PURE__ */ v(S, { component: "li", sx: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ n(
      hl,
      {
        className: "marker",
        mr: 1.5,
        component: "span",
        icon: r,
        maskedIcon: o,
        isStrokeColor: t,
        color: i
      }
    ),
    /* @__PURE__ */ n(Lt, { title: e, visible: !0 })
  ] });
}
const Ze = 6, rt = {
  0: 12,
  1: 9,
  2: 6,
  3: 3
}, ml = m(S, {
  shouldForwardProp: (e) => e !== "index"
})(({ index: e = 0, theme: t }) => {
  const i = t.spacing(rt[e]), r = t.spacing(rt[e]);
  return {
    border: `solid 1px ${t.palette.divider}`,
    backgroundColor: t.palette.background.default,
    borderRadius: "50%",
    position: "absolute",
    right: 0,
    bottom: 0,
    width: i,
    height: r
  };
}), yl = m(S)(({ theme: { spacing: e } }) => ({
  display: "flex",
  justifyContent: "flex-end",
  flexShrink: 0,
  position: "relative",
  width: e(rt[0]),
  height: e(rt[0])
})), wl = m(S)(({ theme: { spacing: e } }) => ({
  display: "flex",
  gap: e(1),
  alignItems: "stretch",
  justifyContent: "stretch",
  padding: e(2, 0)
})), vl = m(S)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  gap: 1,
  flexGrow: 1,
  flexShrink: 1
}));
function xl({
  legend: e
}) {
  const t = se(), i = ce(t), r = e.showMinMax ?? !0, { min: o, max: a, error: l } = bl(e), [d, s] = l ? [0, 0] : kl(o, a);
  return /* @__PURE__ */ v(wl, { "data-testid": "proportion-legend", children: [
    /* @__PURE__ */ n(yl, { children: [...Array(4)].map((u, p) => /* @__PURE__ */ n(
      ml,
      {
        index: p,
        component: "span"
      },
      p
    )) }),
    /* @__PURE__ */ n(vl, { children: l ? /* @__PURE__ */ n(S, { maxWidth: 240, children: /* @__PURE__ */ n(H, { variant: "overline", children: "You need to specify valid numbers for the labels property" }) }) : /* @__PURE__ */ v(ie, { children: [
      /* @__PURE__ */ v(H, { variant: "overline", color: "textSecondary", children: [
        r && i.formatMessage({ id: "c4r.widgets.legend.max" }) + ": ",
        t.formatNumber(a, {
          maximumSignificantDigits: Ze
        })
      ] }),
      /* @__PURE__ */ n(H, { variant: "overline", color: "textSecondary", children: t.formatNumber(s, {
        maximumSignificantDigits: Ze
      }) }),
      /* @__PURE__ */ n(H, { variant: "overline", color: "textSecondary", children: t.formatNumber(d, {
        maximumSignificantDigits: Ze
      }) }),
      /* @__PURE__ */ v(H, { variant: "overline", color: "textSecondary", children: [
        r && i.formatMessage({ id: "c4r.widgets.legend.min" }) + ": ",
        t.formatNumber(o, {
          maximumSignificantDigits: Ze
        })
      ] })
    ] }) })
  ] });
}
function Yn({ labels: e }) {
  let t = e == null ? void 0 : e[e.length - 1], i = e == null ? void 0 : e[0];
  return Number.isFinite(i) || (i = parseInt(String(i), 10)), Number.isFinite(t) || (t = parseInt(String(t), 10)), [i, t];
}
function bl(e) {
  let t = !1;
  const [i, r] = Yn(e);
  return (Number.isNaN(i) || Number.isNaN(r)) && (t = !0), { min: i, max: r, error: t };
}
function kl(e, t) {
  const i = (t - e) / 3;
  return [e + i, t - i];
}
function Sl({
  legend: e
}) {
  const { labels: t = [], icons: i = [] } = e;
  return /* @__PURE__ */ n(jn, { "data-testid": "icon-legend", children: t.map((r, o) => /* @__PURE__ */ v(al, { children: [
    /* @__PURE__ */ n(ll, { children: /* @__PURE__ */ n(
      "img",
      {
        src: i[o],
        alt: r,
        width: "auto",
        height: pt
      }
    ) }),
    /* @__PURE__ */ n(Lt, { visible: !0, title: r })
  ] }, r)) });
}
function Ml(e) {
  return typeof e[0] == "object" && "label" in e[0];
}
function en({
  isContinuous: e = !1,
  legend: t
}) {
  const { labels: i = [], colors: r = [], showMinMax: o = !0 } = t, a = wn(
    r,
    !i.length || e ? 2 : i.length + 1
  ), l = Ml(i), d = l ? i.map(({ value: f }) => f) : i, s = l ? i.map(({ label: f }) => f) : i, [u, p] = Yn({ labels: d }), c = Number.isNaN(u) || Number.isNaN(p);
  let y = s[s.length - 1], g = s[0];
  return !e && o && (g = "< " + g, y = "≥ " + y), /* @__PURE__ */ n(S, { py: 2, "data-testid": "ramp-legend", children: c ? /* @__PURE__ */ n(S, { maxWidth: 240, children: /* @__PURE__ */ n(H, { variant: "overline", children: "You need to specify valid numbers for the labels property" }) }) : /* @__PURE__ */ v(ie, { children: [
    /* @__PURE__ */ n(S, { display: "flex", pb: 1, children: e ? /* @__PURE__ */ n(
      Il,
      {
        "data-testid": "step-continuous",
        palette: a
      }
    ) : /* @__PURE__ */ n(
      Cl,
      {
        palette: a,
        labels: s,
        max: y,
        min: g
      }
    ) }),
    /* @__PURE__ */ v(S, { display: "flex", justifyContent: "space-between", children: [
      /* @__PURE__ */ n(H, { variant: "overlineDelicate", color: "textSecondary", children: g }),
      /* @__PURE__ */ n(H, { variant: "overlineDelicate", color: "textSecondary", children: y })
    ] })
  ] }) });
}
const Il = m(S, {
  shouldForwardProp: (e) => e !== "palette"
})(({ palette: e, theme: t }) => ({
  display: "block",
  flexGrow: 1,
  height: t.spacing(1),
  borderRadius: t.spacing(0.5),
  background: `linear-gradient(to right, ${e.join()})`
})), Tl = m(S, {
  shouldForwardProp: (e) => e !== "color"
})(({ color: e, theme: t }) => ({
  display: "block",
  flexGrow: 1,
  height: t.spacing(1),
  backgroundColor: e,
  "&:first-of-type": {
    borderRadius: t.spacing(0.5, 0, 0, 0.5)
  },
  "&:last-of-type": {
    borderRadius: t.spacing(0, 0.5, 0.5, 0)
  }
}));
function Cl({
  labels: e = [],
  palette: t = [],
  max: i,
  min: r
}) {
  const o = e.length ? [r, ...e] : [r, i];
  return /* @__PURE__ */ n(ie, { children: o.map((a, l) => {
    const d = l === 0 ? r : l === o.length - 1 ? i : `${a} - ${o[l + 1]}`;
    return /* @__PURE__ */ n(ue, { title: d, children: /* @__PURE__ */ n(Tl, { "data-testid": "step-discontinuous", color: t[l] }) }, l);
  }) });
}
const Al = {
  [Ie.CATEGORY]: ul,
  [Ie.PROPORTION]: xl,
  [Ie.ICON]: Sl,
  [Ie.BINS]: (e) => /* @__PURE__ */ n(en, { ...e, isContinuous: !1 }),
  [Ie.CONTINUOUS_RAMP]: (e) => /* @__PURE__ */ n(en, { ...e, isContinuous: !0 })
};
function El({ legend: e }) {
  const t = se(), i = ce(t);
  return e.select || !e.type ? null : /* @__PURE__ */ v(H, { variant: "body2", color: "textSecondary", component: "p", children: [
    e.type,
    " ",
    i.formatMessage({ id: "c4r.widgets.legend.notSupported" }),
    "."
  ] });
}
function Ll(e) {
  return e.type === Ie.PROPORTION ? "c4r.widgets.legend.subtitles.proportion" : e.type === Ie.ICON || e.customMarkers ? "c4r.widgets.legend.subtitles.icon" : e.isStrokeColor ? "c4r.widgets.legend.subtitles.strokeColor" : "c4r.widgets.legend.subtitles.color";
}
function Dl({
  layer: e,
  legend: t,
  customLegendTypes: i,
  onChangeSelection: r
}) {
  var p;
  const o = se(), a = ce(o), l = t.type, s = Al[l] ?? i[l] ?? El, u = ((p = t.select) == null ? void 0 : p.options) ?? [];
  return /* @__PURE__ */ v(S, { component: "li", "data-testid": "legend-layer-variable", px: 2, children: [
    t.attr ? /* @__PURE__ */ v(S, { pb: 1, children: [
      /* @__PURE__ */ n(
        H,
        {
          gutterBottom: !0,
          variant: "overlineDelicate",
          color: "textSecondary",
          component: "p",
          children: a.formatMessage({ id: Ll(t) })
        }
      ),
      /* @__PURE__ */ n(H, { variant: "caption", component: "p", children: t.attr })
    ] }) : null,
    t.select ? /* @__PURE__ */ v(S, { pb: 1, children: [
      /* @__PURE__ */ n(H, { variant: "caption", weight: "medium", component: "p", children: t.select.label }),
      /* @__PURE__ */ n(
        gi,
        {
          "data-testid": "legend-layer-variable-select",
          name: "legend-select",
          value: t.select.value,
          renderValue: (c) => {
            var y;
            return ((y = u.find((g) => g.value === c)) == null ? void 0 : y.label) ?? c;
          },
          onChange: (c) => r(c.target.value),
          MenuProps: {
            transformOrigin: { vertical: "bottom", horizontal: "left" },
            anchorOrigin: { vertical: "top", horizontal: "left" },
            PaperProps: {
              style: {
                maxHeight: 240
              }
            }
          },
          children: u.map((c) => /* @__PURE__ */ n(Pe, { value: c.value, children: /* @__PURE__ */ n(hi, { primary: c.label }) }, c.value))
        }
      )
    ] }) : null,
    /* @__PURE__ */ n(s, { layer: e, legend: t })
  ] });
}
const $l = {};
function Vn(e) {
  return e ? Array.isArray(e) ? e.every((t) => Vn(t)) : !e.select && !e.type : !0;
}
function tn({
  customLegendTypes: e = $l,
  layer: t,
  onChangeCollapsed: i,
  onChangeOpacity: r,
  onChangeVisibility: o,
  onChangeSelection: a,
  maxZoom: l = 21,
  minZoom: d = 0,
  currentZoom: s = 0
}) {
  const u = se(), p = ce(u), c = re(null), [y, g] = _(!1), f = t.id, w = t.title, h = t.visible ?? !0, b = t.switchable ?? !0, k = t.collapsed ?? !1, M = (t.collapsible ?? !0) && !Vn(t.legend), T = t.opacity ?? 1, x = t.showOpacityControl ?? !0, A = h && !k, C = A ? /* @__PURE__ */ n(fn, {}) : /* @__PURE__ */ n(mn, {}), O = (t == null ? void 0 : t.minZoom) !== void 0 || (t == null ? void 0 : t.maxZoom) !== void 0, L = t.minZoom ?? d, P = t.maxZoom ?? l, $ = O && (L > d || P < l), W = s < L || s > P, J = Pl({
    intl: p,
    minZoom: d,
    maxZoom: l,
    layerMinZoom: L,
    layerMaxZoom: P
  }), G = t.helperText ?? ($ ? J : ""), D = F(() => t.legend ? Array.isArray(t.legend) ? t.legend : [t.legend] : [], [t.legend]);
  return t.legend ? /* @__PURE__ */ v(sl, { "data-testid": "legend-layer", "aria-label": w, children: [
    /* @__PURE__ */ v(nl, { ref: c, children: [
      M && /* @__PURE__ */ n(
        fe,
        {
          size: "small",
          "aria-label": p.formatMessage({
            id: k ? "c4r.widgets.legend.expand" : "c4r.widgets.legend.collapse"
          }),
          disabled: !h,
          onClick: () => i({ id: f, collapsed: !k }),
          children: C
        }
      ),
      /* @__PURE__ */ v(cl, { children: [
        /* @__PURE__ */ n(Lt, { visible: h, title: w ?? "" }),
        $ && /* @__PURE__ */ n(
          ue,
          {
            title: p.formatMessage({
              id: "c4r.widgets.legend.zoomLevelTooltip"
            }),
            children: /* @__PURE__ */ v(
              H,
              {
                color: h ? "textPrimary" : "textSecondary",
                variant: "caption",
                component: "p",
                children: [
                  p.formatMessage({
                    id: "c4r.widgets.legend.zoomLevel"
                  }),
                  " ",
                  t.minZoom,
                  " - ",
                  t.maxZoom
                ]
              }
            )
          }
        )
      ] }),
      x && h && !k && /* @__PURE__ */ n(
        dl,
        {
          menuRef: c,
          open: y,
          toggleOpen: g,
          opacity: T,
          onChange: (N) => r({ id: f, opacity: N })
        }
      ),
      b && /* @__PURE__ */ n(
        ue,
        {
          title: p.formatMessage({
            id: h ? "c4r.widgets.legend.hideLayer" : "c4r.widgets.legend.showLayer"
          }),
          children: /* @__PURE__ */ n(
            fe,
            {
              size: "small",
              onClick: () => o({
                id: f,
                collapsed: h ? k : !1,
                visible: !h
              }),
              children: h ? /* @__PURE__ */ n(Ai, {}) : /* @__PURE__ */ n(Ei, {})
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ v(St, { unmountOnExit: !0, timeout: 100, in: A, children: [
      /* @__PURE__ */ n(
        ol,
        {
          "data-testid": "legend-layer-variable-list",
          opacity: W ? 0.5 : 1,
          children: D.map((N, I) => /* @__PURE__ */ n(
            Dl,
            {
              legend: N,
              layer: t,
              customLegendTypes: e,
              onChangeSelection: (R) => a({ id: f, index: I, selection: R })
            },
            `${N.type}-${I}`
          ))
        }
      ),
      G && /* @__PURE__ */ n(
        H,
        {
          variant: "caption",
          color: "textSecondary",
          component: "div",
          p: 2,
          children: /* @__PURE__ */ n("div", { dangerouslySetInnerHTML: { __html: G } })
        }
      )
    ] })
  ] }) : null;
}
function Pl({
  intl: e,
  minZoom: t,
  maxZoom: i,
  layerMinZoom: r,
  layerMaxZoom: o
}) {
  const a = e.formatMessage({ id: "c4r.widgets.legend.and" }), l = e.formatMessage({ id: "c4r.widgets.legend.lowerThan" }), d = e.formatMessage({
    id: "c4r.widgets.legend.greaterThan"
  }), s = e.formatMessage({ id: "c4r.widgets.legend.zoomNote" }), u = o < i ? `${l} ${o}` : "", p = r > t ? `${d} ${r}` : "", c = [u, p].filter(Boolean).join(` ${a} `);
  return c ? `${s} ${c}` : "";
}
const Ol = {}, ze = () => {
}, Wl = [];
function ms({
  customLegendTypes: e = Ol,
  layers: t = Wl,
  collapsed: i = !1,
  onChangeCollapsed: r = ze,
  onChangeVisibility: o = ze,
  onChangeOpacity: a = ze,
  onChangeLegendRowCollapsed: l = ze,
  onChangeSelection: d = ze,
  title: s = "Layers",
  maxZoom: u = 20,
  minZoom: p = 0,
  currentZoom: c,
  isMobile: y,
  sx: g
}) {
  const f = se(), w = ce(f), h = /* @__PURE__ */ v(tl, { collapsed: i, children: [
    /* @__PURE__ */ n(H, { variant: "caption", flexGrow: 1, children: s }),
    /* @__PURE__ */ n(
      ue,
      {
        title: w.formatMessage({ id: "c4r.widgets.legend.close" }),
        children: /* @__PURE__ */ n(fe, { size: "small", onClick: () => r(!0), children: /* @__PURE__ */ n(Li, {}) })
      }
    )
  ] }), b = /* @__PURE__ */ n(
    ue,
    {
      title: w.formatMessage({ id: "c4r.widgets.legend.open" }),
      children: /* @__PURE__ */ n(fe, { "aria-label": s, onClick: () => r(!1), children: /* @__PURE__ */ n(Di, {}) })
    }
  );
  return /* @__PURE__ */ n(el, { sx: g, elevation: 3, collapsed: i || !!y, children: y ? /* @__PURE__ */ v(ie, { children: [
    b,
    /* @__PURE__ */ v(
      fi,
      {
        anchor: "bottom",
        open: !i,
        onClose: () => r(!0),
        children: [
          h,
          /* @__PURE__ */ n(Qt, { children: t.map((k) => /* @__PURE__ */ n(
            tn,
            {
              layer: k,
              onChangeCollapsed: l,
              onChangeOpacity: a,
              onChangeVisibility: o,
              onChangeSelection: d,
              maxZoom: u,
              minZoom: p,
              currentZoom: c,
              customLegendTypes: e
            },
            k.id
          )) })
        ]
      }
    )
  ] }) : /* @__PURE__ */ v(ie, { children: [
    i ? b : h,
    /* @__PURE__ */ n(Qt, { width: i ? 0 : void 0, children: /* @__PURE__ */ n(St, { unmountOnExit: !0, in: !i, timeout: 500, children: t.map((k) => /* @__PURE__ */ n(
      tn,
      {
        layer: k,
        onChangeCollapsed: l,
        onChangeOpacity: a,
        onChangeVisibility: o,
        onChangeSelection: d,
        maxZoom: u,
        minZoom: p,
        currentZoom: c,
        customLegendTypes: e
      },
      k.id
    )) }) })
  ] }) });
}
function nn({
  color: e = void 0,
  children: t
}) {
  return t ? /* @__PURE__ */ n(S, { mt: 0.5, children: /* @__PURE__ */ n(
    H,
    {
      component: "div",
      variant: "caption",
      color: e ?? "inherit",
      style: { fontWeight: "normal" },
      children: t
    }
  ) }) : /* @__PURE__ */ n(S, { mt: -1 });
}
function ys({
  title: e = "No data available",
  body: t = "There are no results for the combination of filters applied to your data. Try tweaking your filters, or zoom and pan the map to adjust the Map View.",
  severity: i = void 0,
  ...r
}) {
  return i ? /* @__PURE__ */ n(Pi, { title: e, severity: i, ...r, children: /* @__PURE__ */ n(nn, { children: t }) }) : /* @__PURE__ */ v(S, { ...r, children: [
    e && /* @__PURE__ */ n(H, { variant: "body2", children: e }),
    /* @__PURE__ */ n(nn, { color: "textSecondary", children: t })
  ] });
}
const Rl = m(S, {
  shouldForwardProp: (e) => e !== "margin"
})(({ theme: e, margin: t }) => ({
  margin: 0,
  position: "relative",
  maxWidth: "100%",
  padding: t ?? e.spacing(2, 2.5)
})), Fl = m(yi)(({ theme: e }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: e.spacing(0.25)
})), Nl = m(ae, {
  shouldForwardProp: (e) => e !== "expanded"
})(({ theme: e, expanded: t = !0 }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-between",
  width: "100%",
  ...t ? { minHeight: e.spacing(3) } : { height: e.spacing(3) },
  padding: 0
})), Bl = m($e, {
  shouldForwardProp: (e) => e !== "expandable"
})(({ theme: e, expandable: t = !0 }) => ({
  flex: 1,
  padding: 0,
  alignItems: "flex-start",
  justifyContent: "flex-start",
  height: "auto",
  minHeight: "auto",
  marginBottom: e.spacing(1),
  cursor: t ? "pointer" : "default",
  "& .MuiButton-startIcon": {
    marginTop: "3px",
    marginRight: e.spacing(1)
  },
  "&:hover": {
    background: "none"
  }
})), Gn = ({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: e.spacing(3),
  height: e.spacing(3),
  color: e.palette.text.secondary
}), _l = m(fn)(({ theme: e }) => Gn({ theme: e })), Hl = m(mn)(({ theme: e }) => Gn({ theme: e })), zl = m(De, {
  shouldForwardProp: (e) => e !== "expanded"
})(({ expanded: e = !0 }) => ({
  wordBreak: "break-word",
  overflow: "hidden",
  ...e && {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical"
  },
  ...!e && {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
})), jl = m(ae)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  marginRight: e.spacing(-0.5),
  marginLeft: e.spacing(1)
})), rn = m(fe)(({ theme: e }) => ({
  color: e.palette.text.secondary
})), Yl = m(kt)(({ theme: e }) => ({
  ".MuiPaper-root": {
    marginTop: e.spacing(5),
    maxHeight: e.spacing(21),
    minWidth: e.spacing(16)
  }
})), on = [], Vl = /* @__PURE__ */ n($i, {});
function ws({
  title: e,
  actions: t = on,
  options: i = on,
  optionsIcon: r = Vl,
  children: o,
  contentProps: a,
  disabled: l = !1,
  expandable: d = !0,
  expanded: s = !0,
  onExpandedChange: u,
  footer: p,
  headerItems: c,
  isLoading: y = !1,
  margin: g
}) {
  const f = ii(), [w, h] = _(!0), b = s !== void 0 && u !== void 0, k = d !== !1 ? b ? s : w : !0, M = b ? u : h, [T, x] = _(null), A = !!T, C = () => {
    d && M(!k);
  }, O = (W) => x(W.currentTarget), L = () => x(null);
  function P(W) {
    W && W(), L();
  }
  const $ = (W) => /* @__PURE__ */ n(
    rn,
    {
      "aria-label": W.label,
      onClick: W.action,
      size: "small",
      children: W.icon
    },
    W.id
  );
  return l ? o ? /* @__PURE__ */ n(ie, { children: o }) : null : /* @__PURE__ */ v(Rl, { margin: g, component: "section", "aria-label": e, children: [
    y ? /* @__PURE__ */ n(Fl, {}) : null,
    /* @__PURE__ */ v(Nl, { container: !0, expanded: s, children: [
      /* @__PURE__ */ n(
        Bl,
        {
          expandable: d,
          startIcon: d && /* @__PURE__ */ n(mi, { children: k ? /* @__PURE__ */ n(_l, {}) : /* @__PURE__ */ n(Hl, {}) }),
          onClick: C,
          tabIndex: d ? 0 : -1,
          children: /* @__PURE__ */ n(ue, { title: e, children: /* @__PURE__ */ n(zl, { expanded: s, align: "left", variant: "subtitle1", children: e }) })
        }
      ),
      /* @__PURE__ */ v(jl, { item: !0, children: [
        c,
        t.length > 0 && t.map((W) => W.tooltip ? /* @__PURE__ */ n(
          ue,
          {
            title: W.tooltip.text,
            placement: W.tooltip.placement ?? "top",
            children: $(W)
          },
          W.id
        ) : $(W)),
        i.length > 0 && /* @__PURE__ */ v(ie, { children: [
          /* @__PURE__ */ n(
            rn,
            {
              "aria-label": "Options",
              "aria-controls": "options-menu",
              "aria-haspopup": "true",
              onClick: O,
              size: "small",
              children: r
            }
          ),
          /* @__PURE__ */ n(
            Yl,
            {
              id: "options-menu",
              elevation: 8,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "right"
              },
              anchorEl: T,
              keepMounted: !0,
              open: A,
              onClose: L,
              children: i.map((W) => /* @__PURE__ */ n(
                Pe,
                {
                  selected: W.selected,
                  onClick: () => P(W.action),
                  children: W.name
                },
                W.id
              ))
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ n(St, { ref: f, in: k, timeout: "auto", unmountOnExit: !0, children: /* @__PURE__ */ v(S, { ...a, children: [
      /* @__PURE__ */ n(S, { pt: 1, children: o }),
      p ?? /* @__PURE__ */ n(S, { children: p })
    ] }) })
  ] });
}
export {
  is as BarWidgetUI,
  rs as CategoryWidgetUI,
  ps as ComparativeCategoryWidgetUI,
  gs as ComparativeFormulaWidgetUI,
  hs as ComparativePieWidgetUI,
  Xa as FeatureSelectionUIDropdown,
  Za as FeatureSelectionUIGeometryChips,
  ja as FeatureSelectionUIToggleButton,
  fs as FeatureSelectionWidgetUI,
  os as FormulaWidgetUI,
  Se as GroupDateTypes,
  as as HistogramWidgetUI,
  Ie as LEGEND_TYPES,
  ul as LegendCategories,
  Sl as LegendIcon,
  xl as LegendProportion,
  en as LegendRamp,
  ms as LegendWidgetUI,
  ys as NoDataAlert,
  ls as PieWidgetUI,
  ss as RangeWidgetUI,
  cs as ScatterPlotWidgetUI,
  It as TIME_SERIES_CHART_TYPES,
  ds as TableWidgetUI,
  Do as TimeSeriesProvider,
  us as TimeSeriesWidgetUI,
  ws as WrapperWidgetUI,
  Et as useTimeSeriesContext,
  $o as useTimeSeriesInteractivity
};
